<template>
  <div class="c1-main cm1-main c1-comms-page" @click="c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1TopTab = null">

    <!-- TOAST -->
    <transition name="cm1-toast-fade">
      <div v-if="cm1Toast" class="cm1-toast" :style="{ background: cm1Toast.color }">{{ cm1Toast.msg }}</div>
    </transition>

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click="cm1SlideOpen = null; c1TopTab = null">
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': cm1PanelActiveContent === 'viki' }"
          @click.stop="cm1SelectPanel('viki')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
          Communications
        </div>
      </div>
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" :class="{ on: $route.path === '/tasks1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" :class="{ on: $route.path === '/stats1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" :class="{ on: $route.path === '/chat1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" :class="{ on: $route.path === '/communications1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP STRIP -->
    <div class="c1-top-strip c1-mod-strip" @click.stop>
      <div class="c1-top-strip-body">
        <div class="c1-ts-tab-row">

          <!-- Channel tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'channel'}" @click.stop="c1TopTab = c1TopTab === 'channel' ? null : 'channel'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            <span>Channel</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='channel' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Status tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
            <span>Status</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Date tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'date'}" @click.stop="c1TopTab = c1TopTab === 'date' ? null : 'date'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>Date</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='date' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Agent tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'agent'}" @click.stop="c1TopTab = c1TopTab === 'agent' ? null : 'agent'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
            <span>Agent</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='agent' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Client tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'client'}" @click.stop="c1TopTab = c1TopTab === 'client' ? null : 'client'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>Client</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='client' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Charts tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            <span>Charts</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>

        </div>

        <!-- Channel dropdown -->
        <div v-show="c1TopTab === 'channel'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Channel</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: filters.channel === 'all' }" @click="cm1SetFilter('channel','all')">All</div>
            <div class="c1-fp-opt cm1-ch-email" :class="{ on: filters.channel === 'email' }" @click="cm1SetFilter('channel','email')">
              <svg viewBox="0 0 24 24" width="11" height="11"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg> Email
            </div>
            <div class="c1-fp-opt cm1-ch-sms" :class="{ on: filters.channel === 'sms' }" @click="cm1SetFilter('channel','sms')">
              <svg viewBox="0 0 24 24" width="11" height="11"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> SMS
            </div>
          </div>
        </div>

        <!-- Status dropdown -->
        <div v-show="c1TopTab === 'status'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Status</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: filters.status === 'all' }" @click="cm1SetFilter('status','all')">All</div>
            <div class="c1-fp-opt cm1-st-sent" :class="{ on: filters.status === 'sent' }" @click="cm1SetFilter('status','sent')">Sent</div>
            <div class="c1-fp-opt cm1-st-delivered" :class="{ on: filters.status === 'delivered' }" @click="cm1SetFilter('status','delivered')">Delivered</div>
            <div class="c1-fp-opt cm1-st-opened" :class="{ on: filters.status === 'opened' }" @click="cm1SetFilter('status','opened')">Opened</div>
            <div class="c1-fp-opt cm1-st-pending" :class="{ on: filters.status === 'pending' }" @click="cm1SetFilter('status','pending')">Pending</div>
            <div class="c1-fp-opt cm1-st-failed" :class="{ on: filters.status === 'failed' }" @click="cm1SetFilter('status','failed')">Failed</div>
            <div class="c1-fp-opt cm1-st-bounced" :class="{ on: filters.status === 'bounced' }" @click="cm1SetFilter('status','bounced')">Bounced</div>
          </div>
        </div>

        <!-- Date dropdown -->
        <div v-show="c1TopTab === 'date'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Date range</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'today' }" @click="cm1ApplyDate('today')">Today</div>
            <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'yesterday' }" @click="cm1ApplyDate('yesterday')">Yesterday</div>
            <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'thisweek' }" @click="cm1ApplyDate('thisweek')">This week</div>
            <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'lastweek' }" @click="cm1ApplyDate('lastweek')">Last week</div>
            <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'thismonth' }" @click="cm1ApplyDate('thismonth')">This month</div>
            <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'lastmonth' }" @click="cm1ApplyDate('lastmonth')">Last month</div>
            <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'all' }" @click="cm1ApplyDate('all')">All time</div>
          </div>
        </div>

        <!-- Agent dropdown -->
        <div v-show="c1TopTab === 'agent'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">
            Agent
            <span v-if="filters.agents && filters.agents.length" class="c1-fp-lbl-badge">{{ filters.agents.length }}</span>
          </div>
          <div class="c1-agent-grid">
            <div
              v-for="agent in cm1AgentList.slice(0, 30)"
              :key="agent.id"
              class="c1-agent-chip"
              :class="{ on: filters.agents && filters.agents.includes(agent.id) }"
              @click="cm1ToggleAgent(agent.id)"
            >
              <div class="c1-agent-av">{{ cm1AgentInitials(agent) }}</div>
              <span class="c1-agent-nm">{{ cm1AgentShortName(agent) }}</span>
            </div>
          </div>
        </div>

        <!-- Client dropdown -->
        <div v-show="c1TopTab === 'client'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Client</div>
          <div class="c1-fp-search">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="filters.client" placeholder="Name, phone, email…" @input="cm1DebounceFetch" />
            <div v-if="filters.client" class="c1-fp-sclear" @click="filters.client = ''; cm1Fetch()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
        </div>

        <!-- Charts dropdown -->
        <div v-show="c1TopTab === 'charts'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-co-lbl">Send volume — last 7 days</div>
          <div class="cm1-stack-chart">
            <div v-for="bar in cm1VolumeBars" :key="bar.label" class="cm1-stack-row">
              <div class="cm1-stack-lbl">{{ bar.label }}</div>
              <div class="cm1-stack-track">
                <div class="cm1-stack-seg cm1-seg-email" :style="{ width: bar.emailPct + '%' }"></div>
                <div class="cm1-stack-seg cm1-seg-sms" :style="{ width: bar.smsPct + '%' }"></div>
              </div>
              <div class="cm1-stack-total">{{ bar.total }}</div>
            </div>
            <div class="cm1-stack-legend">
              <div class="cm1-leg-item"><div class="cm1-leg-dot cm1-seg-email"></div> Email</div>
              <div class="cm1-leg-item"><div class="cm1-leg-dot cm1-seg-sms"></div> SMS</div>
            </div>
          </div>
          <div class="c1-co-lbl" style="margin-top:14px">Delivery &amp; open rates</div>
          <div class="c1-kpi-row">
            <div class="c1-kpi"><div class="c1-kpi-lbl">Sent</div><div class="c1-kpi-val">{{ summary.sent }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Delivered</div><div class="c1-kpi-val" style="color:var(--cm1-green)">{{ summary.delivered }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Delivery %</div><div class="c1-kpi-val" style="color:var(--cm1-green)">{{ cm1DeliveryRate }}%</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Failed</div><div class="c1-kpi-val" style="color:var(--cm1-red)">{{ summary.failed }}</div></div>
          </div>
        </div>

        <div class="c1-nm-div"></div>
        <c1-mod-calendar :items="communications" dateField="created_at" itemLabel="messages" style="flex-shrink:0" />

      </div>
    </div>
    <!-- /TOP STRIP -->

    <!-- PANEL BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="cm1SlideOpen" class="c1-panel-backdrop" @click.stop="cm1SlideOpen = null"></div>
    </transition>

    <!-- UNIFIED PANEL -->
    <div class="c1-panel" :class="{ 'c1-panel--open': cm1PanelIsOpen }" @click.capture="cm1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': cm1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- User strip -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- Timezone bar -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="cm1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="cm1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- ── PANELS MODE ── -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              Filters<span v-if="cm1ActiveFilterCount" class="c1-psel-opt-badge" style="margin-left:6px">{{ cm1ActiveFilterCount }}</span>
            </div>
            <div class="c1-psel-sub" :class="{ on: cm1PanelActiveContent === 'filters' }" @click.stop="cm1SelectPanel('filters')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Channel · Status · Date</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              Analytics
            </div>
            <div class="c1-psel-sub" :class="{ on: cm1PanelActiveContent === 'charts' }" @click.stop="cm1SelectPanel('charts')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Delivery trends · open rate</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: cm1PanelActiveContent === 'calendar' }" @click.stop="cm1SelectPanel('calendar')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Calendar · send history</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              Viki AI
            </div>
            <div class="c1-psel-sub" :class="{ on: cm1PanelActiveContent === 'viki' }" @click.stop="cm1SelectPanel('viki')">
              <span class="c1-psel-sub-dot" style="background:var(--c1-viki)"></span>
              <span class="c1-psel-sub-lbl">AI Insights</span>
              <span v-if="cm1VikiAlerts && cm1VikiAlerts.length" class="c1-psel-opt-badge" style="background:#E05A3A">{{ cm1VikiAlerts.length }}</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="cm1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ cm1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="cm1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- ===== FILTERS CONTENT ===== -->
            <template v-if="cm1PanelActiveContent === 'filters'">
              <div v-if="cm1ActiveFilterCount" class="c1-reset-bar" @click="cm1FullReset">
                <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                Reset all filters
                <span class="c1-reset-bar-count">{{ cm1ActiveFilterCount }}</span>
              </div>
              <!-- Channel -->
              <div class="c1-fp-group">
                <div class="c1-fp-lbl">Channel</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: filters.channel === 'all' }" @click="cm1SetFilter('channel','all')">All</div>
                  <div class="c1-fp-opt cm1-ch-email" :class="{ on: filters.channel === 'email' }" @click="cm1SetFilter('channel','email')">
                    <svg viewBox="0 0 24 24" width="11" height="11"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg> Email
                  </div>
                  <div class="c1-fp-opt cm1-ch-sms" :class="{ on: filters.channel === 'sms' }" @click="cm1SetFilter('channel','sms')">
                    <svg viewBox="0 0 24 24" width="11" height="11"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> SMS
                  </div>
                </div>
              </div>
              <!-- Status -->
              <div class="c1-fp-group">
                <div class="c1-fp-lbl">Status</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: filters.status === 'all' }" @click="cm1SetFilter('status','all')">All</div>
                  <div class="c1-fp-opt cm1-st-sent" :class="{ on: filters.status === 'sent' }" @click="cm1SetFilter('status','sent')">Sent</div>
                  <div class="c1-fp-opt cm1-st-delivered" :class="{ on: filters.status === 'delivered' }" @click="cm1SetFilter('status','delivered')">Delivered</div>
                  <div class="c1-fp-opt cm1-st-opened" :class="{ on: filters.status === 'opened' }" @click="cm1SetFilter('status','opened')">Opened</div>
                  <div class="c1-fp-opt cm1-st-pending" :class="{ on: filters.status === 'pending' }" @click="cm1SetFilter('status','pending')">Pending</div>
                  <div class="c1-fp-opt cm1-st-failed" :class="{ on: filters.status === 'failed' }" @click="cm1SetFilter('status','failed')">Failed</div>
                  <div class="c1-fp-opt cm1-st-bounced" :class="{ on: filters.status === 'bounced' }" @click="cm1SetFilter('status','bounced')">Bounced</div>
                </div>
              </div>
              <!-- Date range -->
              <div class="c1-fp-group">
                <div class="c1-fp-lbl">Date range</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'today' }" @click="cm1ApplyDate('today')">Today</div>
                  <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'yesterday' }" @click="cm1ApplyDate('yesterday')">Yesterday</div>
                  <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'thisweek' }" @click="cm1ApplyDate('thisweek')">This week</div>
                  <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'lastweek' }" @click="cm1ApplyDate('lastweek')">Last week</div>
                  <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'thismonth' }" @click="cm1ApplyDate('thismonth')">This month</div>
                  <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'lastmonth' }" @click="cm1ApplyDate('lastmonth')">Last month</div>
                  <div class="c1-fp-opt" :class="{ on: filters.datePreset === 'all' }" @click="cm1ApplyDate('all')">All time</div>
                </div>
              </div>
              <!-- Client search -->
              <div class="c1-fp-group c1-fp-full">
                <div class="c1-fp-lbl">Client</div>
                <div class="c1-fp-search">
                  <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                  <input class="c1-fp-sinput" v-model.trim="filters.client" placeholder="Name, phone, email…" @input="cm1DebounceFetch" />
                  <div v-if="filters.client" class="c1-fp-sclear" @click="filters.client = ''; cm1Fetch()">
                    <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </div>
                </div>
              </div>
              <!-- Agent filter -->
              <div class="c1-fp-group c1-fp-full">
                <div class="c1-fp-lbl">
                  Agent
                  <span v-if="filters.agents && filters.agents.length" class="c1-fp-lbl-badge">{{ filters.agents.length }}</span>
                </div>
                <div class="c1-agent-grid">
                  <div
                    v-for="agent in cm1AgentList.slice(0, 30)"
                    :key="agent.id"
                    class="c1-agent-chip"
                    :class="{ on: filters.agents && filters.agents.includes(agent.id) }"
                    @click="cm1ToggleAgent(agent.id)"
                  >
                    <div class="c1-agent-av">{{ cm1AgentInitials(agent) }}</div>
                    <span class="c1-agent-nm">{{ cm1AgentShortName(agent) }}</span>
                  </div>
                </div>
              </div>
            </template>

            <!-- ===== CHARTS CONTENT ===== -->
            <template v-if="cm1PanelActiveContent === 'charts'">
              <div class="c1-co-lbl">Send volume — last 7 days</div>
              <div class="cm1-stack-chart">
                <div v-for="bar in cm1VolumeBars" :key="bar.label" class="cm1-stack-row">
                  <div class="cm1-stack-lbl">{{ bar.label }}</div>
                  <div class="cm1-stack-track">
                    <div class="cm1-stack-seg cm1-seg-email" :style="{ width: bar.emailPct + '%' }"></div>
                    <div class="cm1-stack-seg cm1-seg-sms" :style="{ width: bar.smsPct + '%' }"></div>
                  </div>
                  <div class="cm1-stack-total">{{ bar.total }}</div>
                </div>
                <div class="cm1-stack-legend">
                  <div class="cm1-leg-item"><div class="cm1-leg-dot cm1-seg-email"></div> Email</div>
                  <div class="cm1-leg-item"><div class="cm1-leg-dot cm1-seg-sms"></div> SMS</div>
                </div>
              </div>
              <div class="c1-co-lbl" style="margin-top:16px">Delivery &amp; open rates</div>
              <div class="c1-kpi-row">
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Sent</div>
                  <div class="c1-kpi-val">{{ summary.sent }}</div>
                </div>
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Delivered</div>
                  <div class="c1-kpi-val" style="color:var(--cm1-green)">{{ summary.delivered }}</div>
                </div>
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Delivery %</div>
                  <div class="c1-kpi-val" style="color:var(--cm1-green)">{{ cm1DeliveryRate }}%</div>
                </div>
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Failed</div>
                  <div class="c1-kpi-val" style="color:var(--cm1-red)">{{ summary.failed }}</div>
                </div>
              </div>
              <!-- Gauge: delivery rate -->
              <div class="cm1-gauge-wrap" style="margin-top:12px">
                <svg class="cm1-gauge-svg" viewBox="0 0 120 70">
                  <path d="M10,60 A50,50 0 0,1 110,60" fill="none" stroke="var(--cm1-brd)" stroke-width="10" stroke-linecap="round"/>
                  <path d="M10,60 A50,50 0 0,1 110,60" fill="none" stroke="var(--cm1-green)" stroke-width="10" stroke-linecap="round"
                    :stroke-dasharray="cm1GaugeDash(cm1DeliveryRate)" stroke-dashoffset="0"/>
                  <text x="60" y="56" text-anchor="middle" class="cm1-gauge-num">{{ cm1DeliveryRate }}%</text>
                  <text x="60" y="67" text-anchor="middle" class="cm1-gauge-sub">Delivery</text>
                </svg>
                <svg class="cm1-gauge-svg" viewBox="0 0 120 70">
                  <path d="M10,60 A50,50 0 0,1 110,60" fill="none" stroke="var(--cm1-brd)" stroke-width="10" stroke-linecap="round"/>
                  <path d="M10,60 A50,50 0 0,1 110,60" fill="none" stroke="var(--cm1-blue)" stroke-width="10" stroke-linecap="round"
                    :stroke-dasharray="cm1GaugeDash(cm1OpenRate)" stroke-dashoffset="0"/>
                  <text x="60" y="56" text-anchor="middle" class="cm1-gauge-num">{{ cm1OpenRate }}%</text>
                  <text x="60" y="67" text-anchor="middle" class="cm1-gauge-sub">Open rate</text>
                </svg>
              </div>
              <!-- Email vs SMS donut -->
              <div class="c1-co-lbl" style="margin-top:16px">Email vs SMS breakdown</div>
              <div class="cm1-donut-wrap">
                <svg class="cm1-donut-svg" viewBox="0 0 80 80">
                  <circle cx="40" cy="40" r="30" fill="none" stroke="var(--cm1-brd)" stroke-width="14"/>
                  <circle cx="40" cy="40" r="30" fill="none" stroke="var(--cm1-email)" stroke-width="14"
                    :stroke-dasharray="cm1EmailDonutDash" stroke-dashoffset="0"
                    transform="rotate(-90 40 40)"/>
                  <circle cx="40" cy="40" r="30" fill="none" stroke="var(--cm1-sms)" stroke-width="14"
                    :stroke-dasharray="cm1SmsDonutDash" :stroke-dashoffset="cm1SmsDonutOffset"
                    transform="rotate(-90 40 40)"/>
                </svg>
                <div class="cm1-donut-legend">
                  <div class="cm1-leg-item"><div class="cm1-leg-dot cm1-seg-email"></div> Email {{ cm1EmailPct }}%</div>
                  <div class="cm1-leg-item"><div class="cm1-leg-dot cm1-seg-sms"></div> SMS {{ cm1SmsPct }}%</div>
                </div>
              </div>
              <!-- Open rate 7-day trend -->
              <div class="c1-co-lbl" style="margin-top:16px">Open rate trend — 7 days</div>
              <div class="cm1-trend-chart">
                <div v-for="(pt, i) in cm1OpenTrend" :key="i" class="cm1-trend-col">
                  <div class="cm1-trend-bar" :style="{ height: (pt.pct || 2) + '%' }" :title="pt.pct + '%'"></div>
                  <div class="cm1-trend-lbl">{{ pt.label }}</div>
                </div>
              </div>
            </template>

            <!-- ===== CALENDAR CONTENT ===== -->
            <template v-if="cm1PanelActiveContent === 'calendar'">
              <div class="cm1-cal-hdr">
                <button class="cm1-cal-nav" @click="cm1CalPrev">
                  <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
                </button>
                <div class="cm1-cal-title">{{ cm1CalMonthNames[cm1Cal.month] }} {{ cm1Cal.year }}</div>
                <button class="cm1-cal-nav" @click="cm1CalNext">
                  <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
                </button>
              </div>
              <div class="cm1-cal-dow">
                <div v-for="d in ['M','T','W','T','F','S','S']" :key="d + Math.random()" class="cm1-cal-dh">{{ d }}</div>
              </div>
              <div v-for="(week, wi) in cm1CalGrid" :key="wi" class="cm1-cal-week">
                <div
                  v-for="day in week"
                  :key="day.date"
                  class="cm1-cal-day"
                  :class="{
                    'cm1-cal-out': !day.inMonth,
                    'cm1-cal-today': day.today,
                    'cm1-cal-sel': cm1Cal.selected === day.date,
                    'cm1-cal-has': cm1DayHasActivity(day.date)
                  }"
                  @click="cm1SelectDay(day.date)"
                >
                  <span>{{ day.day }}</span>
                  <div v-if="cm1DayHasActivity(day.date)" class="cm1-cal-dot"></div>
                </div>
              </div>
              <div v-if="cm1Cal.selected" class="cm1-cal-day-result">
                <div class="c1-fp-lbl" style="margin-bottom:8px">
                  {{ cm1Cal.selected }} — {{ cm1DayComms(cm1Cal.selected).length }} message(s)
                </div>
                <div
                  v-for="comm in cm1DayComms(cm1Cal.selected)"
                  :key="comm.id"
                  class="cm1-cal-row"
                  @click="cm1OpenDetail(comm)"
                >
                  <div class="cm1-row-ch" :class="'cm1-ch-bg-' + comm.channel" v-html="cm1ChannelIcon(comm.channel)"></div>
                  <div class="cm1-cal-row-body">
                    <div class="cm1-cal-row-client">{{ comm.client_name }}</div>
                    <div class="cm1-cal-row-preview">{{ comm.preview }}</div>
                  </div>
                  <div class="cm1-st-chip" :class="'cm1-st-' + comm.status">{{ comm.status }}</div>
                </div>
                <div v-if="!cm1DayComms(cm1Cal.selected).length" class="cm1-cal-empty">No communications on this day</div>
              </div>
            </template>

            <!-- ===== VIKI CONTENT ===== -->
            <template v-if="cm1PanelActiveContent === 'viki'">
              <div class="c1-co-lbl">Failed send alerts</div>
              <div v-if="cm1VikiAlerts.length === 0" class="cm1-viki-ok">
                <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                All clear — no failed sends
              </div>
              <div v-for="alert in cm1VikiAlerts" :key="alert.id" class="cm1-viki-alert" :class="'cm1-viki-' + alert.type">
                <div class="cm1-viki-alert-icon">
                  <svg v-if="alert.type === 'bounce'" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  <svg v-else-if="alert.type === 'failed'" viewBox="0 0 24 24"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  <svg v-else viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                </div>
                <div class="cm1-viki-alert-body">
                  <div class="cm1-viki-alert-title">{{ alert.title }}</div>
                  <div class="cm1-viki-alert-msg">{{ alert.message }}</div>
                </div>
                <button class="cm1-viki-alert-fix" @click="cm1VikiFixAlert(alert)">Fix</button>
              </div>
              <div class="c1-co-lbl" style="margin-top:16px">Daily quota</div>
              <div class="cm1-quota-bar-wrap">
                <div class="cm1-quota-labels">
                  <span>Email sent today</span>
                  <span>{{ quotaUsed.email }} / {{ quotaLimit.email }}</span>
                </div>
                <div class="cm1-quota-track">
                  <div class="cm1-quota-fill cm1-quota-email" :style="{ width: Math.min((quotaUsed.email / quotaLimit.email) * 100, 100) + '%' }"></div>
                </div>
              </div>
              <div class="cm1-quota-bar-wrap" style="margin-top:8px">
                <div class="cm1-quota-labels">
                  <span>SMS sent today</span>
                  <span>{{ quotaUsed.sms }} / {{ quotaLimit.sms }}</span>
                </div>
                <div class="cm1-quota-track">
                  <div class="cm1-quota-fill cm1-quota-sms" :style="{ width: Math.min((quotaUsed.sms / quotaLimit.sms) * 100, 100) + '%' }"></div>
                </div>
              </div>
              <div class="c1-co-lbl" style="margin-top:16px">Active auto-sequences</div>
              <div v-if="!cm1Sequences.length" class="cm1-viki-ok">No active sequences</div>
              <div v-for="seq in cm1Sequences" :key="seq.client_id" class="cm1-seq-row">
                <div class="cm1-seq-av">{{ cm1AgentAv(seq.client_name) }}</div>
                <div class="cm1-seq-body">
                  <div class="cm1-seq-name">{{ seq.client_name }}</div>
                  <div class="cm1-seq-desc">{{ seq.label }} — Day {{ seq.day_sent }} sent<span v-if="seq.day_next">, Day {{ seq.day_next }} pending (in {{ seq.days_until }} day{{ seq.days_until !== 1 ? 's' : '' }})</span></div>
                </div>
                <div class="cm1-seq-ch cm1-ch-bg-email" v-html="cm1ChannelIcon('email')"></div>
              </div>
              <div class="c1-co-lbl" style="margin-top:16px">Bounce-backs (cannot send until fixed)</div>
              <div v-if="!cm1Bounced.length" class="cm1-viki-ok">No bounced addresses</div>
              <div v-for="b in cm1Bounced" :key="b.id" class="cm1-bounce-row">
                <div class="cm1-bounce-addr">{{ b.address }}</div>
                <div class="cm1-bounce-client">{{ b.client_name }}</div>
                <div class="cm1-bounce-reason">{{ b.reason }}</div>
              </div>
            </template>

          </div>
        </div>
      </div>
    </div>

    <!-- ===== TAB BAR ===== -->
    <div class="cm1-tab-bar">
      <div
        v-for="tab in cm1Tabs"
        :key="tab.id"
        class="cm1-tab"
        :class="{ 'cm1-tab--active': cm1ActiveTab === tab.id }"
        @click="cm1SwitchTab(tab.id)"
      >{{ tab.label }}</div>
    </div>

    <!-- ===== SUMMARY STRIP ===== -->
    <div class="cm1-summary" v-show="cm1ActiveTab === 'email' || cm1ActiveTab === 'sms'">
      <div class="cm1-sum-item">
        <div class="cm1-sum-val">{{ summary.sent }}</div>
        <div class="cm1-sum-lbl">Sent today</div>
      </div>
      <div class="cm1-sum-sep"></div>
      <div class="cm1-sum-item">
        <div class="cm1-sum-val cm1-green">{{ summary.delivered }}</div>
        <div class="cm1-sum-lbl">Delivered</div>
      </div>
      <div class="cm1-sum-sep"></div>
      <div class="cm1-sum-item">
        <div class="cm1-sum-val cm1-red">{{ summary.failed }}</div>
        <div class="cm1-sum-lbl">Failed</div>
      </div>
      <div class="cm1-sum-sep"></div>
      <div class="cm1-sum-item">
        <div class="cm1-sum-val cm1-amber">{{ summary.bounced }}</div>
        <div class="cm1-sum-lbl">Bounced</div>
      </div>
      <div class="cm1-sum-sep"></div>
      <div class="cm1-sum-item">
        <div class="cm1-sum-val cm1-purple">{{ summary.opened }}</div>
        <div class="cm1-sum-lbl">Opened</div>
      </div>
      <div class="cm1-sum-sep"></div>
      <div class="cm1-sum-item">
        <div class="cm1-sum-val cm1-blue">{{ summary.replyRate }}%</div>
        <div class="cm1-sum-lbl">Reply rate</div>
      </div>
      <div class="c1-hp"></div>
      <button class="cm1-compose-btn" @click="cm1OpenCompose">
        <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        New
      </button>
    </div>

    <!-- ===== LOADING ===== -->
    <div v-if="loading && (cm1ActiveTab === 'email' || cm1ActiveTab === 'sms')" class="c1-loading">
      <div class="c1-spinner"></div>
      <div style="font-size:11px;color:var(--cm1-t3);margin-top:8px">Loading…</div>
    </div>

    <!-- ===== ASSIGNMENTS TAB ===== -->
    <div v-if="cm1ActiveTab === 'assignments'" class="cm1-tab-content">
      <div class="cm1-tab-section-title">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>
        Assignment Stats
      </div>
      <div v-if="cm1AssignLoading" class="cm1-tab-loading"><div class="c1-spinner"></div></div>
      <div v-else class="cm1-stats-table">
        <div class="cm1-stats-thead">
          <div class="cm1-stats-th" style="flex:2">Agent Name</div>
          <div class="cm1-stats-th">Total Assigned</div>
          <div class="cm1-stats-th">Today</div>
          <div class="cm1-stats-th">This Week</div>
          <div class="cm1-stats-th">Conversion %</div>
        </div>
        <div v-if="!cm1AssignData.length" class="cm1-tab-empty">No assignment data available</div>
        <div v-for="row in cm1AssignData" :key="row.agent_id" class="cm1-stats-row">
          <div class="cm1-stats-td" style="flex:2">
            <div class="cm1-stats-av">{{ cm1AgentAv(row.agent_name) }}</div>
            {{ row.agent_name }}
          </div>
          <div class="cm1-stats-td">{{ row.total }}</div>
          <div class="cm1-stats-td cm1-green">{{ row.today }}</div>
          <div class="cm1-stats-td">{{ row.this_week }}</div>
          <div class="cm1-stats-td" :class="row.conversion >= 10 ? 'cm1-green' : 'cm1-amber'">{{ row.conversion }}%</div>
        </div>
      </div>
    </div>

    <!-- ===== DAILY STATS TAB ===== -->
    <div v-if="cm1ActiveTab === 'dailystats'" class="cm1-tab-content">
      <div class="cm1-tab-section-title">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
        Daily Performance — Today
      </div>
      <div v-if="cm1DailyStatsLoading" class="cm1-tab-loading"><div class="c1-spinner"></div></div>
      <div v-else class="cm1-stats-table">
        <div class="cm1-stats-thead">
          <div class="cm1-stats-th" style="flex:2">Agent</div>
          <div class="cm1-stats-th">Calls</div>
          <div class="cm1-stats-th">Deposits</div>
          <div class="cm1-stats-th">Transfers</div>
          <div class="cm1-stats-th">NI</div>
          <div class="cm1-stats-th">NA</div>
        </div>
        <div v-if="!cm1DailyStatsData.length" class="cm1-tab-empty">No daily stats available</div>
        <div v-for="row in cm1DailyStatsData" :key="row.agent_id" class="cm1-stats-row">
          <div class="cm1-stats-td" style="flex:2">
            <div class="cm1-stats-av">{{ cm1AgentAv(row.agent_name) }}</div>
            {{ row.agent_name }}
          </div>
          <div class="cm1-stats-td">{{ row.calls }}</div>
          <div class="cm1-stats-td cm1-green">{{ row.deposits }}</div>
          <div class="cm1-stats-td cm1-blue">{{ row.transfers }}</div>
          <div class="cm1-stats-td cm1-amber">{{ row.ni }}</div>
          <div class="cm1-stats-td cm1-red">{{ row.na }}</div>
        </div>
      </div>
    </div>

    <!-- ===== DEPOSITS REPORT TAB ===== -->
    <div v-if="cm1ActiveTab === 'deposits'" class="cm1-tab-content">
      <div class="cm1-tab-section-title">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
        Deposits Report
      </div>
      <div v-if="cm1DepositsLoading" class="cm1-tab-loading"><div class="c1-spinner"></div></div>
      <div v-else class="cm1-stats-table">
        <div class="cm1-stats-thead">
          <div class="cm1-stats-th">Date</div>
          <div class="cm1-stats-th" style="flex:2">Client</div>
          <div class="cm1-stats-th">Amount</div>
          <div class="cm1-stats-th">Currency</div>
          <div class="cm1-stats-th">Broker</div>
          <div class="cm1-stats-th">Agent</div>
        </div>
        <div v-if="!cm1DepositsData.length" class="cm1-tab-empty">No deposits found</div>
        <div v-for="dep in cm1DepositsData" :key="dep.id" class="cm1-stats-row">
          <div class="cm1-stats-td cm1-mono" style="font-size:10px">{{ cm1FmtTime(dep.created_at) }}</div>
          <div class="cm1-stats-td" style="flex:2;font-weight:600">{{ dep.client_name }}</div>
          <div class="cm1-stats-td cm1-green" style="font-weight:600">${{ dep.amount }}</div>
          <div class="cm1-stats-td">{{ dep.currency || 'USD' }}</div>
          <div class="cm1-stats-td">{{ dep.broker || '—' }}</div>
          <div class="cm1-stats-td">{{ dep.agent_name || '—' }}</div>
        </div>
      </div>
    </div>

    <!-- ===== MAIN COMM LIST ===== -->
    <div v-if="!loading && (cm1ActiveTab === 'email' || cm1ActiveTab === 'sms')" class="cm1-list">

      <div v-if="!cm1Filtered.length" class="c1-empty">
        <div class="c1-empty-icon">
          <svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        </div>
        <div class="c1-empty-msg">No communications found</div>
      </div>

      <div v-for="comm in cm1Filtered" :key="comm.id" class="cm1-row" :class="{ 'cm1-row-bounced': comm.status === 'bounced' }">

        <!-- ROW HEAD -->
        <div
          class="cm1-row-head"
          :class="{ 'cm1-row-expanded': cm1Expanded === comm.id }"
          @click="cm1ToggleRow(comm.id)"
        >
          <!-- Channel accent bar -->
          <div class="cm1-row-acc" :class="'cm1-acc-' + comm.channel"></div>

          <!-- Timestamp -->
          <div class="cm1-row-ts">{{ cm1FmtTime(comm.sent_at) }}</div>

          <!-- Channel icon bubble -->
          <div class="cm1-row-ch" :class="'cm1-ch-bg-' + comm.channel" v-html="cm1ChannelIcon(comm.channel)"></div>

          <!-- Status chip -->
          <div class="cm1-st-chip" :class="'cm1-st-' + comm.status">{{ comm.status }}</div>

          <!-- Client -->
          <div class="cm1-row-client" :class="{ 'cm1-bounced-name': comm.status === 'bounced' }">{{ comm.client_name }}</div>

          <!-- Subject / preview -->
          <div class="cm1-row-subject">
            <span v-if="comm.subject" class="cm1-row-subj-text">{{ comm.subject }} — </span>
            <span class="cm1-row-preview">{{ comm.preview }}</span>
          </div>

          <!-- Agent avatar -->
          <div class="cm1-row-agent" :title="comm.agent_name">{{ cm1AgentAv(comm.agent_name) }}</div>

          <!-- Chevron -->
          <svg class="cm1-row-chv" :class="{ open: cm1Expanded === comm.id }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
        </div>

        <!-- EXPANDED BODY -->
        <div v-if="cm1Expanded === comm.id" class="cm1-row-body">

          <!-- Bounce warning banner -->
          <div v-if="comm.status === 'bounced'" class="cm1-bounce-banner">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <strong>Bounced:</strong> {{ comm.bounce_reason || 'Address rejected by receiving server' }} — cannot send again until address is fixed.
          </div>

          <!-- Spam / send block warnings -->
          <div v-if="cm1HasSendWarning(comm)" class="cm1-spam-banner">
            <svg viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            Warning: message may contain spam words or missing fields — review before resending
          </div>

          <!-- Unsubscribe status -->
          <div v-if="comm.unsubscribed" class="cm1-unsub-banner">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
            Client is unsubscribed — no marketing emails can be sent
          </div>

          <!-- Full message -->
          <div class="cm1-exp-sec">
            <div class="cm1-exp-lbl">Message</div>
            <div class="cm1-exp-msg">{{ comm.body }}</div>
          </div>

          <!-- Thread (reply history) -->
          <div v-if="comm.thread && comm.thread.length" class="cm1-exp-sec">
            <div class="cm1-exp-lbl">Thread ({{ comm.thread.length }} messages)</div>
            <div class="cm1-thread" :class="{ 'cm1-thread-scroll': comm.thread.length > 10 }">
              <div
                v-for="(msg, mi) in (comm.showHistory ? comm.thread : comm.thread.slice(0,10))"
                :key="mi"
                class="cm1-thread-msg"
                :class="{ 'cm1-thread-inbound': msg.direction === 'in', 'cm1-thread-outbound': msg.direction === 'out' }"
              >
                <div class="cm1-thread-meta">
                  <span class="cm1-thread-who">{{ msg.direction === 'in' ? comm.client_name : msg.agent }}</span>
                  <span class="cm1-thread-ts cm1-mono">{{ cm1FmtFull(msg.ts) }}</span>
                </div>
                <div class="cm1-thread-body">{{ msg.body }}</div>
              </div>
              <div v-if="comm.thread.length > 10 && !comm.showHistory" class="cm1-thread-more" @click="$set(comm, 'showHistory', true)">
                Show {{ comm.thread.length - 10 }} older messages
              </div>
            </div>
          </div>

          <!-- Meta grid -->
          <div class="cm1-exp-grid">
            <div class="cm1-exp-field">
              <div class="cm1-exp-fl">Client</div>
              <div class="cm1-exp-fv">{{ comm.client_name }}</div>
            </div>
            <div class="cm1-exp-field">
              <div class="cm1-exp-fl">Contact</div>
              <div class="cm1-exp-fv cm1-mono">{{ comm.client_contact }}</div>
            </div>
            <div class="cm1-exp-field">
              <div class="cm1-exp-fl">Agent</div>
              <div class="cm1-exp-fv">{{ comm.agent_name }}</div>
            </div>
            <div class="cm1-exp-field">
              <div class="cm1-exp-fl">Template</div>
              <div class="cm1-exp-fv">{{ comm.template || '—' }}</div>
            </div>
            <div class="cm1-exp-field">
              <div class="cm1-exp-fl">Sent</div>
              <div class="cm1-exp-fv cm1-mono">{{ cm1FmtFull(comm.sent_at) }}</div>
            </div>
            <div class="cm1-exp-field">
              <div class="cm1-exp-fl">Delivered</div>
              <div class="cm1-exp-fv cm1-mono">{{ comm.delivered_at ? cm1FmtFull(comm.delivered_at) : '—' }}</div>
            </div>
            <div v-if="comm.opened_at" class="cm1-exp-field">
              <div class="cm1-exp-fl">Opened</div>
              <div class="cm1-exp-fv cm1-mono">{{ cm1FmtFull(comm.opened_at) }}</div>
            </div>
            <div v-if="comm.message_id" class="cm1-exp-field cm1-exp-full">
              <div class="cm1-exp-fl">Message ID</div>
              <div class="cm1-exp-fv cm1-mono" style="font-size:10px;word-break:break-all">{{ comm.message_id }}</div>
            </div>
          </div>

          <!-- Actions -->
          <div class="cm1-exp-actions">
            <button class="cm1-act-btn cm1-act-detail" @click.stop="cm1OpenDetail(comm)">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Full detail
            </button>
            <button
              v-if="comm.status === 'failed' && !comm.unsubscribed && comm.status !== 'bounced'"
              class="cm1-act-btn cm1-act-retry"
              @click.stop="cm1Retry(comm)"
            >
              <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.87"/></svg>
              Retry
            </button>
            <button
              v-if="comm.status !== 'bounced' && !comm.unsubscribed"
              class="cm1-act-btn cm1-act-compose"
              @click.stop="cm1ReplyTo(comm)"
            >
              <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              Reply
            </button>
            <!-- UNSUBSCRIBE — most prominent button -->
            <button
              v-if="!comm.unsubscribed && comm.channel === 'email'"
              class="cm1-act-btn cm1-act-unsub"
              @click.stop="cm1Unsubscribe(comm)"
            >
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
              Unsubscribe
            </button>
            <span v-if="comm.unsubscribed" class="cm1-act-unsub-badge">Unsubscribed</span>
            <router-link
              v-if="comm.client_id"
              :to="'/client/' + comm.client_id"
              class="cm1-act-btn cm1-act-client"
              @click.native.stop
            >
              <svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              Client
            </router-link>
          </div>

          <!-- SMS deposit management reply (if deposit SMS) -->
          <div v-if="comm.channel === 'sms' && comm.sms_type === 'deposit'" class="cm1-exp-sec" style="margin-top:10px">
            <div class="cm1-exp-lbl">Management reply</div>
            <div class="cm1-mgmt-btns">
              <button class="cm1-mgmt-btn cm1-mgmt-congrats" @click.stop="cm1MgmtReply(comm, 'Congratulations!')">Congratulations</button>
              <button class="cm1-mgmt-btn cm1-mgmt-great" @click.stop="cm1MgmtReply(comm, 'Great job!')">Great Job</button>
              <button class="cm1-mgmt-btn cm1-mgmt-more" @click.stop="cm1MgmtReply(comm, 'Do 1 more!')">Do 1 more</button>
              <button class="cm1-mgmt-btn cm1-mgmt-close" @click.stop="cm1MgmtReply(comm, 'Close the deal!')">Close</button>
              <div class="cm1-mgmt-free">
                <input
                  class="cm1-mgmt-input"
                  v-model="cm1MgmtFreeText[comm.id]"
                  maxlength="40"
                  placeholder="Free text (40 chars)…"
                  @click.stop
                />
                <button class="cm1-mgmt-send" @click.stop="cm1MgmtReply(comm, cm1MgmtFreeText[comm.id])">Send</button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Pagination -->
      <div class="c1-pg-bar" v-if="pagination.total > pagination.perPage">
        <div class="c1-pg-btn" :class="{ disabled: pagination.page <= 1 }" @click="cm1GoPage(1)">
          <svg viewBox="0 0 24 24"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg>
        </div>
        <div class="c1-pg-btn" :class="{ disabled: pagination.page <= 1 }" @click="cm1GoPage(pagination.page - 1)">
          <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
        </div>
        <div class="c1-pg-info">{{ pagination.from }}–{{ pagination.to }} of {{ pagination.total }}</div>
        <div class="c1-hp"></div>
        <div class="c1-pg-btn" :class="{ disabled: pagination.page >= pagination.lastPage }" @click="cm1GoPage(pagination.page + 1)">
          <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
        </div>
        <div class="c1-pg-btn" :class="{ disabled: pagination.page >= pagination.lastPage }" @click="cm1GoPage(pagination.lastPage)">
          <svg viewBox="0 0 24 24"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
        </div>
      </div>

    </div>

    <!-- ===== RIGHT DRAWER — full email detail + thread ===== -->
    <transition name="cm1-drawer">
      <div v-if="cm1DetailOpen" class="cm1-drawer-wrap" @click.self="cm1DetailOpen = false">
        <div class="cm1-drawer">
          <div class="cm1-drawer-head">
            <div class="cm1-drawer-ch" :class="cm1DetailComm ? 'cm1-ch-bg-' + cm1DetailComm.channel : ''" v-html="cm1DetailComm ? cm1ChannelIcon(cm1DetailComm.channel) : ''"></div>
            <div class="cm1-drawer-title">
              <div class="cm1-drawer-name">{{ cm1DetailComm && cm1DetailComm.client_name }}</div>
              <div class="cm1-drawer-sub cm1-mono">{{ cm1DetailComm && cm1DetailComm.client_contact }}</div>
            </div>
            <div v-if="cm1DetailComm" class="cm1-st-chip" :class="'cm1-st-' + cm1DetailComm.status" style="margin-left:auto">{{ cm1DetailComm.status }}</div>
            <button class="cm1-drawer-close" @click="cm1DetailOpen = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="cm1-drawer-body" v-if="cm1DetailComm">

            <!-- Bounce banner in detail -->
            <div v-if="cm1DetailComm.status === 'bounced'" class="cm1-bounce-banner">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              <strong>Bounced:</strong> {{ cm1DetailComm.bounce_reason || 'Address rejected' }} — cannot send again until address is fixed.
            </div>

            <!-- Unsubscribe status prominent -->
            <div v-if="cm1DetailComm.unsubscribed" class="cm1-unsub-banner">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
              Client is unsubscribed from email communications
            </div>

            <!-- UNSUBSCRIBE BUTTON — most prominent -->
            <button
              v-if="!cm1DetailComm.unsubscribed && cm1DetailComm.channel === 'email'"
              class="cm1-unsub-main-btn"
              @click="cm1Unsubscribe(cm1DetailComm)"
            >
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
              Unsubscribe this client from emails
            </button>

            <!-- Full message -->
            <div class="cm1-exp-sec">
              <div class="cm1-exp-lbl">Full message</div>
              <div class="cm1-exp-msg cm1-exp-msg-lg">{{ cm1DetailComm.body }}</div>
            </div>

            <!-- Thread in detail -->
            <div v-if="cm1DetailComm.thread && cm1DetailComm.thread.length" class="cm1-exp-sec">
              <div class="cm1-exp-lbl">
                Thread ({{ cm1DetailComm.thread.length }})
                <span v-if="cm1DetailComm.thread.length > 10" class="cm1-thread-tab-hint">Showing newest first</span>
              </div>
              <div class="cm1-thread cm1-thread-scroll">
                <div
                  v-for="(msg, mi) in (cm1DetailShowHistory ? cm1DetailComm.thread : cm1DetailComm.thread.slice().reverse().slice(0,10))"
                  :key="mi"
                  class="cm1-thread-msg"
                  :class="{ 'cm1-thread-inbound': msg.direction === 'in', 'cm1-thread-outbound': msg.direction === 'out' }"
                >
                  <div class="cm1-thread-meta">
                    <span class="cm1-thread-who">{{ msg.direction === 'in' ? cm1DetailComm.client_name : (msg.agent || 'Agent') }}</span>
                    <span class="cm1-thread-ts cm1-mono">{{ cm1FmtFull(msg.ts) }}</span>
                  </div>
                  <div class="cm1-thread-body">{{ msg.body }}</div>
                </div>
              </div>
              <div v-if="cm1DetailComm.thread.length > 10 && !cm1DetailShowHistory" class="cm1-thread-hist-btn" @click="cm1DetailShowHistory = true">
                Show full history ({{ cm1DetailComm.thread.length - 10 }} more)
              </div>
            </div>

            <!-- Delivery timeline -->
            <div class="cm1-exp-sec">
              <div class="cm1-exp-lbl">Delivery timeline</div>
              <div class="cm1-timeline">
                <div class="cm1-tl-item cm1-tl-sent">
                  <div class="cm1-tl-dot"></div>
                  <div class="cm1-tl-label">Sent</div>
                  <div class="cm1-tl-time cm1-mono">{{ cm1FmtFull(cm1DetailComm.sent_at) }}</div>
                </div>
                <div class="cm1-tl-item" :class="cm1DetailComm.delivered_at ? 'cm1-tl-delivered' : 'cm1-tl-pending'">
                  <div class="cm1-tl-dot"></div>
                  <div class="cm1-tl-label">Delivered</div>
                  <div class="cm1-tl-time cm1-mono">{{ cm1DetailComm.delivered_at ? cm1FmtFull(cm1DetailComm.delivered_at) : '—' }}</div>
                </div>
                <div v-if="cm1DetailComm.channel === 'email'" class="cm1-tl-item" :class="cm1DetailComm.opened_at ? 'cm1-tl-opened' : 'cm1-tl-pending'">
                  <div class="cm1-tl-dot"></div>
                  <div class="cm1-tl-label">Opened</div>
                  <div class="cm1-tl-time cm1-mono">{{ cm1DetailComm.opened_at ? cm1FmtFull(cm1DetailComm.opened_at) : '—' }}</div>
                </div>
                <div v-if="cm1DetailComm.status === 'bounced'" class="cm1-tl-item cm1-tl-bounced">
                  <div class="cm1-tl-dot"></div>
                  <div class="cm1-tl-label">Bounced</div>
                  <div class="cm1-tl-time cm1-mono">{{ cm1DetailComm.bounce_reason || 'Address invalid' }}</div>
                </div>
              </div>
            </div>

            <!-- Details grid -->
            <div class="cm1-exp-sec">
              <div class="cm1-exp-lbl">Details</div>
              <div class="cm1-exp-grid">
                <div class="cm1-exp-field">
                  <div class="cm1-exp-fl">Agent</div>
                  <div class="cm1-exp-fv">{{ cm1DetailComm.agent_name }}</div>
                </div>
                <div class="cm1-exp-field">
                  <div class="cm1-exp-fl">Channel</div>
                  <div class="cm1-exp-fv" style="text-transform:capitalize">{{ cm1DetailComm.channel }}</div>
                </div>
                <div v-if="cm1DetailComm.template" class="cm1-exp-field cm1-exp-full">
                  <div class="cm1-exp-fl">Template</div>
                  <div class="cm1-exp-fv">{{ cm1DetailComm.template }}</div>
                </div>
                <div v-if="cm1DetailComm.message_id" class="cm1-exp-field cm1-exp-full">
                  <div class="cm1-exp-fl">Message ID</div>
                  <div class="cm1-exp-fv cm1-mono" style="font-size:10px;word-break:break-all">{{ cm1DetailComm.message_id }}</div>
                </div>
              </div>
            </div>

            <!-- Reply input -->
            <div v-if="cm1DetailComm.status !== 'bounced' && !cm1DetailComm.unsubscribed" class="cm1-exp-sec">
              <div class="cm1-exp-lbl">Quick reply <span style="opacity:.5">(max 160 chars)</span></div>
              <div class="cm1-reply-wrap">
                <textarea
                  class="cm1-reply-input"
                  v-model="cm1DetailReply"
                  maxlength="160"
                  rows="3"
                  placeholder="Type reply… (160 char max)"
                ></textarea>
                <div class="cm1-reply-footer">
                  <span class="cm1-compose-count">{{ cm1DetailReply.length }}/160</span>
                  <button class="cm1-reply-send-btn" :disabled="!cm1DetailReply.trim()" @click="cm1SendDetailReply">
                    <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                    Send reply
                  </button>
                </div>
              </div>
            </div>

            <!-- Actions -->
            <div class="cm1-exp-sec">
              <div class="cm1-exp-lbl">Actions</div>
              <div class="cm1-drawer-actions">
                <button class="cm1-dact-btn cm1-dact-forward" @click="cm1Forward(cm1DetailComm)">
                  <svg viewBox="0 0 24 24"><polyline points="15 17 20 12 15 7"/><path d="M4 18v-2a4 4 0 0 1 4-4h12"/></svg>
                  Forward
                </button>
                <button class="cm1-dact-btn cm1-dact-important" @click="cm1MarkImportant(cm1DetailComm)" :class="{ on: cm1DetailComm.important }">
                  <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  {{ cm1DetailComm.important ? 'Unmark' : 'Important' }}
                </button>
                <router-link v-if="cm1DetailComm.client_id" :to="'/client/' + cm1DetailComm.client_id" class="cm1-dact-btn cm1-dact-client" @click.native="cm1DetailOpen = false">
                  <svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  View client
                </router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </transition>

    <!-- ===== LEFT DRAWER — compose ===== -->
    <transition name="cm1-compose">
      <div v-if="cm1ComposeOpen" class="cm1-compose-wrap" @click.self="cm1ComposeOpen = false">
        <div class="cm1-compose-panel">
          <div class="cm1-compose-head">
            <svg viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            <span>New message</span>
            <div class="c1-hp"></div>
            <button class="cm1-drawer-close" @click="cm1ComposeOpen = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="cm1-compose-body">

            <!-- Channel select -->
            <div class="cm1-compose-group">
              <label class="cm1-compose-lbl">Channel</label>
              <div class="c1-fp-opts">
                <div class="c1-fp-opt cm1-ch-email" :class="{ on: compose.channel === 'email' }" @click="compose.channel = 'email'; compose.template = ''">
                  <svg viewBox="0 0 24 24" width="11" height="11"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg> Email
                </div>
                <div class="c1-fp-opt cm1-ch-sms" :class="{ on: compose.channel === 'sms' }" @click="compose.channel = 'sms'; compose.template = ''">
                  <svg viewBox="0 0 24 24" width="11" height="11"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> SMS
                </div>
              </div>
            </div>

            <!-- To — client search -->
            <div class="cm1-compose-group">
              <label class="cm1-compose-lbl">To — client</label>
              <div class="c1-fp-search" style="position:relative">
                <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <input
                  class="c1-fp-sinput"
                  v-model="compose.clientSearch"
                  placeholder="Search client name…"
                  @input="cm1SearchClients"
                />
              </div>
              <!-- Client suggestions dropdown -->
              <div v-if="cm1ClientSuggestions.length" class="cm1-client-dropdown">
                <div
                  v-for="c in cm1ClientSuggestions"
                  :key="c.id"
                  class="cm1-client-opt"
                  @click="cm1SelectClient(c)"
                >
                  <span class="cm1-client-opt-name">{{ c.first_name }} {{ c.last_name }}</span>
                  <span class="cm1-client-opt-contact cm1-mono">{{ c.email || c.phone }}</span>
                </div>
              </div>
              <div v-if="compose.clientId" class="cm1-client-selected">
                <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                {{ compose.clientSearch }} selected
              </div>
            </div>

            <!-- Email: preset template (agents use presets only) -->
            <div v-if="compose.channel === 'email'" class="cm1-compose-group">
              <label class="cm1-compose-lbl">
                Preset template
                <span class="cm1-compose-rule-note">Agents must use presets — mass email forbidden</span>
              </label>
              <div class="cm1-preset-grid">
                <div
                  v-for="t in cm1EmailPresets"
                  :key="t.id"
                  class="cm1-preset-card"
                  :class="{ on: compose.template === t.id }"
                  @click="cm1ApplyPreset(t)"
                >
                  <div class="cm1-preset-name">{{ t.name }}</div>
                  <div class="cm1-preset-preview">{{ t.body.substring(0,60) }}…</div>
                </div>
              </div>
            </div>

            <!-- SMS: free text (160 chars) -->
            <div v-if="compose.channel === 'sms'" class="cm1-compose-group">
              <label class="cm1-compose-lbl">SMS message <span style="opacity:.5">(max 160 chars)</span></label>
              <textarea
                class="cm1-compose-textarea"
                v-model="compose.body"
                maxlength="160"
                rows="4"
                placeholder="Type SMS message (160 char max)…"
              ></textarea>
              <div class="cm1-compose-count" :class="{ 'cm1-count-warn': compose.body.length > 140 }">
                {{ compose.body.length }}/160
              </div>
            </div>

            <!-- Email body (if preset, shown read-only with 160-char override) -->
            <div v-if="compose.channel === 'email' && compose.template" class="cm1-compose-group">
              <label class="cm1-compose-lbl">Message preview</label>
              <div class="cm1-exp-msg" style="font-size:12px;max-height:120px;overflow-y:auto">{{ compose.body }}</div>
              <label class="cm1-compose-lbl" style="margin-top:8px">Custom note <span style="opacity:.5">(max 160 chars, appended)</span></label>
              <textarea
                class="cm1-compose-textarea"
                v-model="compose.customNote"
                maxlength="160"
                rows="2"
                placeholder="Optional personal note appended to preset…"
              ></textarea>
              <div class="cm1-compose-count" :class="{ 'cm1-count-warn': (compose.customNote || '').length > 140 }">
                {{ (compose.customNote || '').length }}/160
              </div>
            </div>

            <!-- Spam / block warning -->
            <div v-if="cm1ComposeWarning" class="cm1-compose-warning">
              <svg viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              {{ cm1ComposeWarning }}
            </div>

            <!-- Schedule toggle -->
            <div class="cm1-compose-group">
              <div class="cm1-schedule-row" @click="compose.scheduled = !compose.scheduled">
                <div class="cm1-schedule-toggle" :class="{ on: compose.scheduled }">
                  <div class="cm1-schedule-dot"></div>
                </div>
                <span class="cm1-compose-lbl" style="margin:0 0 0 8px;cursor:pointer">Schedule for later</span>
              </div>
              <input
                v-if="compose.scheduled"
                class="cm1-compose-input"
                type="datetime-local"
                v-model="compose.scheduledAt"
                style="margin-top:8px"
              />
            </div>

            <!-- Send button -->
            <button
              class="cm1-compose-send"
              :disabled="cm1ComposeSendDisabled"
              @click="cm1SendMessage"
            >
              <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
              {{ compose.scheduled ? 'Schedule' : 'Send now' }}
            </button>

          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import { mapState } from "vuex";
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

const API = "/api";
const SPAM_WORDS = ["free money","win","winner","congratulations","click here","buy now","limited offer","act now","guarantee","risk-free","no cost","!!!"];

export default {
  name: "Communications1Container",

  components: { VikiFace, C1ModCalendar },

  computed: {
    ...mapState("user", ["auth"]),

    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return [u.first_name, u.last_name].filter(Boolean).join(" ") || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "";
      const map = { admin: "Admin", manager: "Manager", agent: "Agent", broker: "Broker" };
      return map[u.role] || u.role || "";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    cm1PanelIsOpen() {
      return !!this.cm1SlideOpen && this.cm1SlideOpen !== 'menu';
    },
    cm1PanelAtContent() {
      return this.cm1PanelIsOpen && this.cm1SlideOpen !== 'nav';
    },
    cm1ActivePanelLabel() {
      if (!this.cm1PanelIsOpen || this.cm1SlideOpen === 'nav') return 'Panels';
      return this.cm1PanelActiveContent ? (this.cm1PanelActiveContent.charAt(0).toUpperCase() + this.cm1PanelActiveContent.slice(1)) : 'Panels';
    },

    cm1UserInitials() {
      const u = this.auth && this.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },

    cm1AgentList() {
      return (this.$store.state.clients && this.$store.state.clients.salesPersonList) || [];
    },

    cm1ActiveFilterCount() {
      let n = 0;
      if (this.filters.channel !== "all") n++;
      if (this.filters.status !== "all") n++;
      if (this.filters.datePreset !== "all") n++;
      if (this.filters.client) n++;
      if (this.filters.agents && this.filters.agents.length) n++;
      return n;
    },

    cm1DeliveryRate() {
      if (!this.summary.sent) return 0;
      return Math.round((this.summary.delivered / this.summary.sent) * 100);
    },

    cm1OpenRate() {
      const emails = this.communications.filter(c => c.channel === "email");
      if (!emails.length) return 0;
      return Math.round((emails.filter(c => c.opened_at).length / emails.length) * 100);
    },

    cm1EmailPct() {
      const total = this.communications.length;
      if (!total) return 0;
      return Math.round((this.communications.filter(c => c.channel === "email").length / total) * 100);
    },

    cm1SmsPct() {
      return Math.max(0, 100 - this.cm1EmailPct);
    },

    // SVG donut helpers — circumference of r=30 circle = ~188.5
    cm1EmailDonutDash() {
      const circ = 188.5;
      const fill = (this.cm1EmailPct / 100) * circ;
      return `${fill} ${circ - fill}`;
    },
    cm1SmsDonutDash() {
      const circ = 188.5;
      const fill = (this.cm1SmsPct / 100) * circ;
      return `${fill} ${circ - fill}`;
    },
    cm1SmsDonutOffset() {
      const circ = 188.5;
      return -((this.cm1EmailPct / 100) * circ);
    },

    cm1CalGrid() {
      const { year, month } = this.cm1Cal;
      const first = new Date(year, month, 1);
      const startDow = (first.getDay() + 6) % 7;
      const cursor = new Date(first);
      cursor.setDate(cursor.getDate() - startDow);
      const todayStr = this.cm1DateStr(new Date());
      const weeks = [];
      for (let w = 0; w < 6; w++) {
        const week = [];
        for (let d = 0; d < 7; d++) {
          const dateStr = this.cm1DateStr(cursor);
          week.push({ date: dateStr, day: cursor.getDate(), inMonth: cursor.getMonth() === month, today: dateStr === todayStr });
          cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(week);
        if (w >= 3 && cursor.getMonth() !== month) break;
      }
      return weeks;
    },

    cm1VolumeBars() {
      const days = [];
      const now = new Date();
      for (let i = 6; i >= 0; i--) {
        const d = new Date(now);
        d.setDate(d.getDate() - i);
        const str = this.cm1DateStr(d);
        const dc = this.communications.filter(c => c.sent_at && c.sent_at.startsWith(str));
        const email = dc.filter(c => c.channel === "email").length;
        const sms   = dc.filter(c => c.channel === "sms").length;
        const total = email + sms;
        days.push({
          label: ["Su","Mo","Tu","We","Th","Fr","Sa"][d.getDay()],
          email, sms, total,
          emailPct: total ? Math.round((email / total) * 100) : 0,
          smsPct:   total ? Math.round((sms / total) * 100) : 0
        });
      }
      return days;
    },

    cm1OpenTrend() {
      const days = [];
      const now = new Date();
      for (let i = 6; i >= 0; i--) {
        const d = new Date(now);
        d.setDate(d.getDate() - i);
        const str = this.cm1DateStr(d);
        const dc = this.communications.filter(c => c.sent_at && c.sent_at.startsWith(str));
        const pct = dc.length ? Math.round((dc.filter(c => c.opened_at).length / dc.length) * 100) : 0;
        days.push({ label: ["Su","Mo","Tu","We","Th","Fr","Sa"][d.getDay()], pct });
      }
      return days;
    },

    cm1Filtered() {
      let list = [...this.communications];
      if (this.filters.channel !== "all") list = list.filter(c => c.channel === this.filters.channel);
      if (this.filters.status !== "all")  list = list.filter(c => c.status === this.filters.status);
      if (this.filters.dateFrom) list = list.filter(c => c.sent_at && c.sent_at >= this.filters.dateFrom);
      if (this.filters.dateTo)   list = list.filter(c => c.sent_at && c.sent_at <= this.filters.dateTo + "T23:59:59");
      if (this.filters.client)   list = list.filter(c => (c.client_name || "").toLowerCase().includes(this.filters.client.toLowerCase()) || (c.client_contact || "").toLowerCase().includes(this.filters.client.toLowerCase()));
      if (this.filters.agents && this.filters.agents.length) list = list.filter(c => this.filters.agents.includes(c.agent_id));
      // newest first
      return list.sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));
    },

    cm1Bounced() {
      return this.communications
        .filter(c => c.status === "bounced")
        .map(c => ({ id: c.id, address: c.client_contact, client_name: c.client_name, reason: c.bounce_reason || "Unknown reason" }));
    },

    cm1ComposeWarning() {
      const body = (this.compose.body || "").toLowerCase();
      if (this.compose.channel === "email" && !this.compose.clientId) return null;
      if (body.includes("$") || body.includes("!!!!")) return "Warning: message may be flagged as spam ($, !!!!)";
      for (const w of SPAM_WORDS) { if (body.includes(w)) return `Warning: spam word detected — "${w}"`; }
      if (this.compose.channel === "email" && !this.compose.template && !this.compose.body.trim()) return "Email body is empty";
      return null;
    },

    cm1ComposeSendDisabled() {
      if (!this.compose.clientId) return true;
      if (this.compose.channel === "email" && !this.compose.template) return true;
      if (this.compose.channel === "sms" && !this.compose.body.trim()) return true;
      return false;
    }
  },

  data() {
    const now = new Date();
    return {
      c1Status: 'available',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1TopTab: null,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      cm1SlideOpen: 'nav',
      cm1PanelActiveContent: null,
      cm1Expanded: null,

      // Tab system
      cm1ActiveTab: 'email',
      cm1Tabs: [
        { id: 'email', label: 'EMAIL' },
        { id: 'sms', label: 'SMS' },
        { id: 'assignments', label: 'ASSIGNMENTS' },
        { id: 'dailystats', label: 'DAILY STATS' },
        { id: 'deposits', label: 'DEPOSITS REPORT' }
      ],
      cm1AssignData: [],
      cm1AssignLoading: false,
      cm1DailyStatsData: [],
      cm1DailyStatsLoading: false,
      cm1DepositsData: [],
      cm1DepositsLoading: false,
      cm1UserOnline: true,
      cm1DetailOpen: false,
      cm1DetailComm: null,
      cm1DetailReply: "",
      cm1DetailShowHistory: false,
      cm1ComposeOpen: false,
      cm1TimeStr: "",
      cm1Toast: null,
      cm1ToastTimer: null,
      loading: false,
      cm1ClientSuggestions: [],
      cm1MgmtFreeText: {},

      filters: {
        channel: "all",
        status: "all",
        datePreset: "today",
        dateFrom: [now.getFullYear(), String(now.getMonth()+1).padStart(2,"0"), String(now.getDate()).padStart(2,"0")].join("-"),
        dateTo: [now.getFullYear(), String(now.getMonth()+1).padStart(2,"0"), String(now.getDate()).padStart(2,"0")].join("-"),
        agents: [],
        client: ""
      },

      summary: { sent: 0, delivered: 0, failed: 0, bounced: 0, opened: 0, replyRate: 0 },

      pagination: { page: 1, perPage: 30, total: 0, lastPage: 1, from: 0, to: 0 },

      communications: [
        {
          id: 1, channel: "email", status: "opened",
          client_name: "James Wright", client_id: 1042, client_contact: "james.wright@gmail.com",
          agent_name: "Sarah K", agent_id: 5,
          subject: "Follow-up on your account",
          preview: "Hi James, following up on your account…",
          body: "Hi James,\n\nI wanted to follow up on your account and see if you had any questions about the recent market movements.\n\nWe have some interesting opportunities coming up and I'd love to walk you through them.\n\nBest regards,\nSarah",
          template: "Follow-up v2", message_id: "msg_01HX2K9P3R",
          sent_at: new Date().toISOString(),
          delivered_at: new Date(Date.now() - 2*60000).toISOString(),
          opened_at: new Date(Date.now() - 60000).toISOString(),
          important: false, unsubscribed: false, bounce_reason: null,
          thread: [
            { direction: "out", agent: "Sarah K", ts: new Date(Date.now()-3600000).toISOString(), body: "Hi James, just checking in…" },
            { direction: "in",  ts: new Date(Date.now()-1800000).toISOString(), body: "Thanks, I will get back to you soon." }
          ]
        },
        {
          id: 2, channel: "sms", status: "delivered",
          client_name: "Maria Santos", client_id: 2108, client_contact: "+44 7700 900123",
          agent_name: "David L", agent_id: 7,
          subject: null, preview: "Your verification code is 482910",
          body: "Your GNM verification code is 482910. Valid for 10 minutes. Do not share this code.",
          template: "OTP SMS", message_id: "sms_8dkf92s",
          sent_at: new Date(Date.now() - 3600000).toISOString(),
          delivered_at: new Date(Date.now() - 3598000).toISOString(),
          opened_at: null, important: false, unsubscribed: false, bounce_reason: null, thread: []
        },
        {
          id: 3, channel: "email", status: "bounced",
          client_name: "Lior Ben-David", client_id: 3301, client_contact: "lior.bad@oldmail.il",
          agent_name: "Amir T", agent_id: 9,
          subject: "Important portfolio update",
          preview: "Shalom Lior, we have an update for you…",
          body: "Shalom Lior,\n\nWe have an important update regarding your portfolio. Please contact us at your earliest convenience.",
          template: null, message_id: "email_bounce_009",
          sent_at: new Date(Date.now() - 7200000).toISOString(),
          delivered_at: null, opened_at: null,
          important: true, unsubscribed: false,
          bounce_reason: "550 5.1.1 — User unknown at recipient domain",
          thread: []
        },
        {
          id: 4, channel: "email", status: "sent",
          client_name: "Anna Kowalski", client_id: 4450, client_contact: "anna.k@webmail.pl",
          agent_name: "Sarah K", agent_id: 5,
          subject: "Welcome to GNM",
          preview: "Welcome to GNM — next steps inside",
          body: "Dear Anna,\n\nWelcome to GNM! We're excited to have you on board. Please find your account details and next steps below.\n\nIf you have any questions, don't hesitate to reach out.",
          template: "Welcome email", message_id: "msg_welc_4450",
          sent_at: new Date(Date.now() - 10800000).toISOString(),
          delivered_at: null, opened_at: null,
          important: false, unsubscribed: false, bounce_reason: null, thread: []
        },
        {
          id: 5, channel: "sms", status: "pending",
          client_name: "Robert Chen", client_id: 5012, client_contact: "+61 4 0000 0000",
          agent_name: "David L", agent_id: 7,
          subject: null, preview: "Reminder: your call is scheduled for 3pm",
          body: "Reminder: your scheduled call with your GNM account manager is today at 3:00 PM. Reply STOP to cancel.",
          template: "SC reminder", message_id: null,
          sent_at: new Date(Date.now() + 1800000).toISOString(),
          delivered_at: null, opened_at: null,
          important: false, unsubscribed: false, bounce_reason: null, thread: [],
          sms_type: "deposit"
        },
        {
          id: 6, channel: "sms", status: "sent",
          client_name: "Natalia Perez", client_id: 6001, client_contact: "+34 600 000 000",
          agent_name: "Amir T", agent_id: 9,
          subject: null, preview: "Morning, Carlos did a New Deposit…",
          body: "Good morning Manager, Carlos Ruiz (Agent: Amir T) did a New Deposit 09:30 12/03 Spain $2,500 in BrokerX",
          template: "Deposit announcement", message_id: "sms_dep_6001",
          sent_at: new Date(Date.now() - 5400000).toISOString(),
          delivered_at: new Date(Date.now() - 5398000).toISOString(),
          opened_at: null, important: false, unsubscribed: false, bounce_reason: null,
          sms_type: "deposit", thread: []
        }
      ],

      cm1Cal: { year: now.getFullYear(), month: now.getMonth(), selected: null },
      cm1CalMonthNames: ["January","February","March","April","May","June","July","August","September","October","November","December"],

      cm1EmailPresets: [
        { id: 1, name: "Signals example", body: "Hi {name},\n\nHere's a sample of the trading signals we sent this week — our top pick was up 4.2% in 48 hours. Let me know if you want to see more.\n\nBest,\n{agent}" },
        { id: 2, name: "Watch our video", body: "Hi {name},\n\nI wanted to share a short video with you that explains our platform and how we help clients like you reach their financial goals.\n\nClick here to watch: [link]\n\nBest,\n{agent}" },
        { id: 3, name: "Custom (160 char note)", body: "" }
      ],

      cm1Templates: [],

      cm1Sequences: [
        { client_id: 1042, client_name: "James Wright", label: "NA sequence", day_sent: 1, day_next: 3, days_until: 2 },
        { client_id: 4450, client_name: "Anna Kowalski", label: "Welcome sequence", day_sent: 1, day_next: 5, days_until: 4 }
      ],

      quotaUsed: { email: 47, sms: 23 },
      quotaLimit: { email: 200, sms: 100 },

      compose: {
        channel: "email",
        clientSearch: "",
        clientId: null,
        template: "",
        body: "",
        customNote: "",
        scheduled: false,
        scheduledAt: ""
      },

      cm1FetchTimer: null,
      cm1VikiAlerts: []
    };
  },

  watch: {
    'cm1SlideOpen': function(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.cm1PanelActiveContent = val;
      }
    }
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) {
      sessionStorage.removeItem('c1keepNav');
      this.cm1SlideOpen = 'nav';
      this.c1NavMode = 'panels';
    }
    sessionStorage.removeItem('c1openPanel');
    const tick = () => {
      const d = new Date();
      this.cm1TimeStr = [d.getHours(), d.getMinutes(), d.getSeconds()].map(n => String(n).padStart(2,"0")).join(":");
    };
    tick();
    setInterval(tick, 1000);
    this.cm1BuildSummary();
    this.cm1Fetch();
  },

  mounted() {
    // Shift tracking
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus && !this.c1Status) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.documentElement.style.setProperty('--gnm-sw', '0px');
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },

    // ─── API ───────────────────────────────────────────────────────────────

    async cm1Fetch() {
      this.loading = true;
      try {
        const token = localStorage.getItem("user-token");
        const params = new URLSearchParams();
        if (this.filters.channel !== "all") params.append("channel", this.filters.channel);
        if (this.filters.status !== "all")  params.append("status", this.filters.status);
        if (this.filters.dateFrom) params.append("date_from", this.filters.dateFrom);
        if (this.filters.dateTo)   params.append("date_to", this.filters.dateTo);
        if (this.filters.client)   params.append("client", this.filters.client);
        if (this.filters.agents && this.filters.agents.length) params.append("agents", this.filters.agents.join(","));
        params.append("page", this.pagination.page);
        params.append("per_page", this.pagination.perPage);

        const res = await fetch(`${API}/communications/list?${params.toString()}`, {
          headers: { Authorization: "Bearer " + token }
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const json = await res.json();

        if (json.data) {
          this.communications = json.data;
          this.pagination.total    = json.meta ? json.meta.total    : json.data.length;
          this.pagination.lastPage = json.meta ? json.meta.last_page : 1;
          this.pagination.from     = json.meta ? json.meta.from      : 1;
          this.pagination.to       = json.meta ? json.meta.to        : json.data.length;
        }
        this.cm1BuildSummary();
        this.cm1LoadTemplates();
      } catch (e) {
        console.error("[Comms1] fetch:", e.message);
        // keep mock data on error
        this.cm1BuildSummary();
      } finally {
        this.loading = false;
      }
    },

    async cm1LoadTemplates() {
      try {
        const token = localStorage.getItem("user-token");
        const res = await fetch(`${API}/communications/templates`, {
          headers: { Authorization: "Bearer " + token }
        });
        if (!res.ok) return;
        const json = await res.json();
        if (Array.isArray(json.data)) this.cm1Templates = json.data;
      } catch (e) {
        console.error("[Comms1] templates:", e.message);
      }
    },

    cm1BuildSummary() {
      const today = this.cm1DateStr(new Date());
      const tc = this.communications.filter(c => c.sent_at && c.sent_at.startsWith(today));
      this.summary.sent      = tc.length;
      this.summary.delivered = tc.filter(c => c.delivered_at).length;
      this.summary.failed    = tc.filter(c => c.status === "failed").length;
      this.summary.bounced   = tc.filter(c => c.status === "bounced").length;
      this.summary.opened    = tc.filter(c => c.opened_at).length;
      this.summary.replyRate = this.summary.sent ? Math.round((this.summary.opened / this.summary.sent) * 100) : 0;

      // build viki alerts from bounced + failed
      const alerts = [];
      this.communications.filter(c => c.status === "bounced").forEach(c => {
        alerts.push({ id: "b" + c.id, type: "bounce", title: `Email to ${c.client_name} bounced`, message: c.bounce_reason || "Address rejected by mail server — fix address before resending.", comm: c });
      });
      this.communications.filter(c => c.status === "failed").forEach(c => {
        alerts.push({ id: "f" + c.id, type: "failed", title: `${c.channel.toUpperCase()} to ${c.client_name} failed`, message: "Send failed — retry or check contact details.", comm: c });
      });
      if (this.quotaUsed.email > this.quotaLimit.email * 0.9) {
        alerts.push({ id: "quota_email", type: "warning", title: "Email quota almost full", message: `${this.quotaUsed.email}/${this.quotaLimit.email} emails sent today. Approaching daily limit.` });
      }
      if (this.quotaUsed.sms > this.quotaLimit.sms * 0.9) {
        alerts.push({ id: "quota_sms", type: "warning", title: "SMS quota almost full", message: `${this.quotaUsed.sms}/${this.quotaLimit.sms} SMS sent today.` });
      }
      this.cm1VikiAlerts = alerts;
    },

    async cm1Retry(comm) {
      const token = localStorage.getItem("user-token");
      try {
        const res = await fetch(`${API}/communications/send_email`, {
          method: "POST",
          headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
          body: JSON.stringify({ communication_id: comm.id, retry: true })
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        this.cm1ShowToast("Retry queued", "#6366f1");
        comm.status = "pending";
        this.cm1BuildSummary();
      } catch (e) {
        this.cm1ShowToast("Retry failed: " + e.message, "#ef4444");
      }
    },

    async cm1SendMessage() {
      if (this.cm1ComposeSendDisabled) return;
      const token = localStorage.getItem("user-token");
      const channel = this.compose.channel;
      const endpoint = channel === "email" ? "send_email" : "send_sms";
      const body = channel === "email"
        ? (this.compose.body + (this.compose.customNote ? "\n\n" + this.compose.customNote : ""))
        : this.compose.body;
      try {
        const res = await fetch(`${API}/communications/${endpoint}`, {
          method: "POST",
          headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
          body: JSON.stringify({
            client_id:    this.compose.clientId,
            channel,
            template_id:  this.compose.template || undefined,
            body,
            scheduled_at: this.compose.scheduled ? this.compose.scheduledAt : undefined
          })
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        this.cm1ShowToast(this.compose.scheduled ? "Message scheduled" : "Message sent", "#22c55e");
        this.cm1ComposeOpen = false;
        this.cm1ResetCompose();
        this.cm1Fetch();
      } catch (e) {
        this.cm1ShowToast("Send failed: " + e.message, "#ef4444");
      }
    },

    async cm1SendDetailReply() {
      if (!this.cm1DetailReply.trim() || !this.cm1DetailComm) return;
      const token = localStorage.getItem("user-token");
      const comm = this.cm1DetailComm;
      const endpoint = comm.channel === "email" ? "send_email" : "send_sms";
      try {
        const res = await fetch(`${API}/communications/${endpoint}`, {
          method: "POST",
          headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
          body: JSON.stringify({ client_id: comm.client_id, channel: comm.channel, body: this.cm1DetailReply, reply_to: comm.id })
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        // push to local thread
        if (!comm.thread) this.$set(comm, "thread", []);
        comm.thread.push({ direction: "out", agent: this.cm1UserInitials, ts: new Date().toISOString(), body: this.cm1DetailReply });
        this.cm1DetailReply = "";
        this.cm1ShowToast("Reply sent", "#22c55e");
      } catch (e) {
        this.cm1ShowToast("Reply failed: " + e.message, "#ef4444");
      }
    },

    async cm1MarkImportant(comm) {
      comm.important = !comm.important;
      const token = localStorage.getItem("user-token");
      try {
        await fetch(`${API}/communications/${comm.id}`, {
          method: "PUT",
          headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
          body: JSON.stringify({ important: comm.important })
        });
      } catch (e) { console.error("[Comms1] markImportant:", e.message); }
    },

    async cm1Unsubscribe(comm) {
      const token = localStorage.getItem("user-token");
      try {
        const res = await fetch(`${API}/communications/unsubscribe`, {
          method: "POST",
          headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
          body: JSON.stringify({ client_id: comm.client_id })
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        comm.unsubscribed = true;
        this.cm1ShowToast("Client unsubscribed", "#6366f1");
      } catch (e) {
        // optimistic update even if API unavailable
        comm.unsubscribed = true;
        this.cm1ShowToast("Unsubscribed (local)", "#f59e0b");
      }
    },

    cm1Forward(comm) {
      this.cm1DetailOpen = false;
      this.compose.channel = comm.channel;
      this.compose.body = "FWD: " + comm.body;
      this.compose.clientSearch = "";
      this.compose.clientId = null;
      this.cm1ComposeOpen = true;
    },

    async cm1MgmtReply(comm, text) {
      if (!text || !text.trim()) return;
      const token = localStorage.getItem("user-token");
      try {
        await fetch(`${API}/communications/send_sms`, {
          method: "POST",
          headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
          body: JSON.stringify({ client_id: comm.client_id, channel: "sms", body: text.substring(0, 40) })
        });
        this.cm1ShowToast("Reply sent: " + text.substring(0,20), "#22c55e");
        this.$set(this.cm1MgmtFreeText, comm.id, "");
      } catch (e) {
        this.cm1ShowToast("Failed: " + e.message, "#ef4444");
      }
    },

    async cm1SearchClients() {
      if (!this.compose.clientSearch || this.compose.clientSearch.length < 2) {
        this.cm1ClientSuggestions = [];
        return;
      }
      const token = localStorage.getItem("user-token");
      try {
        const res = await fetch(`${API}/client/list?search=${encodeURIComponent(this.compose.clientSearch)}&per_page=8`, {
          headers: { Authorization: "Bearer " + token }
        });
        if (!res.ok) return;
        const json = await res.json();
        this.cm1ClientSuggestions = json.data || [];
      } catch (e) { this.cm1ClientSuggestions = []; }
    },

    cm1SelectClient(c) {
      this.compose.clientId = c.id;
      this.compose.clientSearch = (c.first_name || "") + " " + (c.last_name || "");
      this.cm1ClientSuggestions = [];
    },

    cm1VikiFixAlert(alert) {
      if (alert.comm) {
        this.cm1OpenDetail(alert.comm);
        this.cm1SlideOpen = null;
      }
    },

    // ─── UI helpers ──────────────────────────────────────────────────────

    cm1PanelBtnClick() {
      this.cm1SlideOpen = this.cm1PanelIsOpen ? null : 'nav';
    },
    cm1SelectPanel(panel) {
      this.cm1SlideOpen = panel;
    },
    cm1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    cm1OpenSlide(name) {
      this.cm1SlideOpen = this.cm1SlideOpen === name ? null : name;
    },

    cm1ToggleRow(id) {
      this.cm1Expanded = this.cm1Expanded === id ? null : id;
    },

    cm1OpenDetail(comm) {
      this.cm1DetailComm = comm;
      this.cm1DetailOpen = true;
      this.cm1DetailReply = "";
      this.cm1DetailShowHistory = false;
    },

    cm1OpenCompose() {
      this.cm1ResetCompose();
      this.cm1ComposeOpen = true;
    },

    cm1ReplyTo(comm) {
      this.cm1DetailOpen = false;
      this.compose.channel = comm.channel;
      this.compose.clientSearch = comm.client_name;
      this.compose.clientId = comm.client_id;
      this.compose.body = "";
      this.compose.template = "";
      this.cm1ComposeOpen = true;
    },

    cm1ResetCompose() {
      this.compose = { channel: "email", clientSearch: "", clientId: null, template: "", body: "", customNote: "", scheduled: false, scheduledAt: "" };
      this.cm1ClientSuggestions = [];
    },

    cm1SetFilter(key, val) {
      this.filters[key] = val;
      this.pagination.page = 1;
      this.cm1Fetch();
    },

    cm1ToggleAgent(id) {
      if (!this.filters.agents) this.$set(this.filters, "agents", []);
      const idx = this.filters.agents.indexOf(id);
      if (idx > -1) this.filters.agents.splice(idx, 1);
      else this.filters.agents.push(id);
      this.pagination.page = 1;
      this.cm1Fetch();
    },

    cm1ApplyDate(preset) {
      this.filters.datePreset = preset;
      const today = this.cm1DateStr(new Date());
      const now = new Date();
      if (preset === "today") {
        this.filters.dateFrom = today; this.filters.dateTo = today;
      } else if (preset === "yesterday") {
        const y = new Date(now); y.setDate(y.getDate() - 1);
        const ys = this.cm1DateStr(y);
        this.filters.dateFrom = ys; this.filters.dateTo = ys;
      } else if (preset === "thisweek") {
        const d = new Date(now); d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
        this.filters.dateFrom = this.cm1DateStr(d); this.filters.dateTo = today;
      } else if (preset === "lastweek") {
        const mon = new Date(now); mon.setDate(mon.getDate() - ((mon.getDay() + 6) % 7) - 7);
        const sun = new Date(mon); sun.setDate(sun.getDate() + 6);
        this.filters.dateFrom = this.cm1DateStr(mon); this.filters.dateTo = this.cm1DateStr(sun);
      } else if (preset === "thismonth") {
        const d = new Date(now.getFullYear(), now.getMonth(), 1);
        this.filters.dateFrom = this.cm1DateStr(d); this.filters.dateTo = today;
      } else if (preset === "lastmonth") {
        const f = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const l = new Date(now.getFullYear(), now.getMonth(), 0);
        this.filters.dateFrom = this.cm1DateStr(f); this.filters.dateTo = this.cm1DateStr(l);
      } else {
        this.filters.dateFrom = null; this.filters.dateTo = null;
      }
      this.pagination.page = 1;
      this.cm1Fetch();
    },

    cm1FullReset() {
      const today = this.cm1DateStr(new Date());
      this.filters = { channel: "all", status: "all", datePreset: "all", dateFrom: null, dateTo: null, agents: [], client: "" };
      this.pagination.page = 1;
      this.cm1Fetch();
    },

    cm1GoPage(page) {
      if (page < 1 || page > this.pagination.lastPage) return;
      this.pagination.page = page;
      this.cm1Fetch();
    },

    cm1ApplyPreset(t) {
      this.compose.template = t.id;
      this.compose.body = t.body;
    },

    cm1DebounceFetch() {
      if (this.cm1FetchTimer) clearTimeout(this.cm1FetchTimer);
      this.cm1FetchTimer = setTimeout(() => this.cm1Fetch(), 350);
    },

    cm1HasSendWarning(comm) {
      const body = (comm.body || "").toLowerCase();
      return body.includes("$$$") || SPAM_WORDS.some(w => body.includes(w));
    },

    // ─── Calendar ──────────────────────────────────────────────────────────

    cm1CalPrev() {
      if (this.cm1Cal.month === 0) { this.cm1Cal.month = 11; this.cm1Cal.year--; }
      else this.cm1Cal.month--;
    },
    cm1CalNext() {
      if (this.cm1Cal.month === 11) { this.cm1Cal.month = 0; this.cm1Cal.year++; }
      else this.cm1Cal.month++;
    },
    cm1SelectDay(dateStr) {
      this.cm1Cal.selected = this.cm1Cal.selected === dateStr ? null : dateStr;
    },
    cm1DayHasActivity(dateStr) {
      return this.communications.some(c => c.sent_at && c.sent_at.startsWith(dateStr));
    },
    cm1DayComms(dateStr) {
      return this.communications.filter(c => c.sent_at && c.sent_at.startsWith(dateStr));
    },

    // ─── Toast ─────────────────────────────────────────────────────────────

    cm1ShowToast(msg, color = "#6366f1") {
      if (this.cm1ToastTimer) clearTimeout(this.cm1ToastTimer);
      this.cm1Toast = { msg, color };
      this.cm1ToastTimer = setTimeout(() => { this.cm1Toast = null; }, 3000);
    },

    // ─── Formatters ────────────────────────────────────────────────────────

    cm1FmtTime(ts) {
      if (!ts) return "—";
      const d = new Date(ts);
      return d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) + " " +
             d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
    },
    cm1FmtFull(ts) {
      if (!ts) return "—";
      return new Date(ts).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    },
    cm1DateStr(d) {
      return [d.getFullYear(), String(d.getMonth()+1).padStart(2,"0"), String(d.getDate()).padStart(2,"0")].join("-");
    },
    cm1ChannelIcon(ch) {
      if (ch === "email") return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
      if (ch === "sms")   return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
    },
    cm1AgentInitials(agent) {
      const name = agent.full_name || agent.name || agent.username || "";
      const parts = name.trim().split(" ");
      return (((parts[0] && parts[0][0]) || "") + ((parts[1] && parts[1][0]) || "")).toUpperCase() || "?";
    },
    cm1AgentShortName(agent) {
      const name = agent.full_name || agent.name || agent.username || "";
      return name.trim().split(" ")[0] || name;
    },
    cm1AgentAv(agentName) {
      if (!agentName) return "?";
      const parts = agentName.trim().split(" ");
      return (((parts[0] && parts[0][0]) || "") + ((parts[1] && parts[1][0]) || "")).toUpperCase();
    },
    cm1GaugeDash(pct) {
      // half-circle arc length ~157
      const arc = 157;
      const fill = (pct / 100) * arc;
      return `${fill} ${arc - fill}`;
    },

    // ─── Tab System ─────────────────────────────────────────────────────
    cm1SwitchTab(tabId) {
      this.cm1ActiveTab = tabId;
      if (tabId === 'email' || tabId === 'sms') {
        this.filters.channel = tabId;
        this.pagination.page = 1;
        this.cm1Fetch();
      } else if (tabId === 'assignments') {
        this.cm1FetchAssignments();
      } else if (tabId === 'dailystats') {
        this.cm1FetchDailyStats();
      } else if (tabId === 'deposits') {
        this.cm1FetchDeposits();
      }
    },

    async cm1FetchAssignments() {
      this.cm1AssignLoading = true;
      try {
        const token = localStorage.getItem("user-token");
        const res = await fetch(`${API}/agents/stats/today`, {
          headers: { Authorization: "Bearer " + token }
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const json = await res.json();
        const raw = json.data || (Array.isArray(json) ? json : []);
        this.cm1AssignData = raw.map(a => ({
          agent_id: a.id || a.agent_id,
          agent_name: a.name || a.agent_name || a.full_name || ((a.first_name || '') + ' ' + (a.last_name || '')).trim() || 'Agent',
          total: a.total_assigned || a.total || 0,
          today: a.today || a.today_assigned || 0,
          this_week: a.this_week || a.week || 0,
          conversion: a.conversion_rate || a.conversion || 0
        }));
      } catch (e) {
        // Mock data for dev
        this.cm1AssignData = [
          { agent_id: 5, agent_name: 'Sarah K', total: 245, today: 12, this_week: 48, conversion: 15 },
          { agent_id: 7, agent_name: 'David L', total: 198, today: 8, this_week: 35, conversion: 11 },
          { agent_id: 9, agent_name: 'Amir T', total: 312, today: 15, this_week: 62, conversion: 18 },
          { agent_id: 11, agent_name: 'Elena M', total: 167, today: 6, this_week: 28, conversion: 9 }
        ];
      } finally {
        this.cm1AssignLoading = false;
      }
    },

    async cm1FetchDailyStats() {
      this.cm1DailyStatsLoading = true;
      try {
        const token = localStorage.getItem("user-token");
        const res = await fetch(`${API}/agents/stats/today`, {
          headers: { Authorization: "Bearer " + token }
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const json = await res.json();
        const raw = json.data || (Array.isArray(json) ? json : []);
        this.cm1DailyStatsData = raw.map(a => ({
          agent_id: a.id || a.agent_id,
          agent_name: a.name || a.agent_name || a.full_name || ((a.first_name || '') + ' ' + (a.last_name || '')).trim() || 'Agent',
          calls: a.calls || a.total_calls || 0,
          deposits: a.deposits || a.total_deposits || 0,
          transfers: a.transfers || a.total_transfers || 0,
          ni: a.ni || a.not_interested || 0,
          na: a.na || a.no_answer || 0
        }));
      } catch (e) {
        this.cm1DailyStatsData = [
          { agent_id: 5, agent_name: 'Sarah K', calls: 42, deposits: 3, transfers: 1, ni: 12, na: 8 },
          { agent_id: 7, agent_name: 'David L', calls: 38, deposits: 2, transfers: 0, ni: 15, na: 6 },
          { agent_id: 9, agent_name: 'Amir T', calls: 55, deposits: 5, transfers: 2, ni: 10, na: 4 },
          { agent_id: 11, agent_name: 'Elena M', calls: 29, deposits: 1, transfers: 1, ni: 9, na: 11 }
        ];
      } finally {
        this.cm1DailyStatsLoading = false;
      }
    },

    async cm1FetchDeposits() {
      this.cm1DepositsLoading = true;
      try {
        const token = localStorage.getItem("user-token");
        const res = await fetch(`${API}/finance/list?type=deposit&per_page=50`, {
          headers: { Authorization: "Bearer " + token }
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const json = await res.json();
        const raw = json.data || (Array.isArray(json) ? json : []);
        this.cm1DepositsData = raw.map(d => ({
          id: d.id,
          created_at: d.created_at || d.date,
          client_name: d.client_name || d.description || 'Client',
          amount: d.amount || 0,
          currency: d.currency || 'USD',
          broker: d.broker || d.payment_method || '—',
          agent_name: d.agent_name || d.user_name || '—'
        }));
      } catch (e) {
        this.cm1DepositsData = [
          { id: 1, created_at: new Date().toISOString(), client_name: 'James Wright', amount: 2500, currency: 'USD', broker: 'BrokerX', agent_name: 'Sarah K' },
          { id: 2, created_at: new Date(Date.now() - 3600000).toISOString(), client_name: 'Maria Santos', amount: 1800, currency: 'EUR', broker: 'AlphaTrade', agent_name: 'David L' },
          { id: 3, created_at: new Date(Date.now() - 7200000).toISOString(), client_name: 'Carlos Ruiz', amount: 5000, currency: 'USD', broker: 'BrokerX', agent_name: 'Amir T' },
          { id: 4, created_at: new Date(Date.now() - 10800000).toISOString(), client_name: 'Anna Kowalski', amount: 1200, currency: 'GBP', broker: 'PrimeFX', agent_name: 'Elena M' }
        ];
      } finally {
        this.cm1DepositsLoading = false;
      }
    }
  },

  // Viki alerts array needs to be reactive — init in data, built in cm1BuildSummary
  // Adding it here so Vue tracks it from the start
  beforeCreate() {
    // ensure cm1VikiAlerts is reactive
  }
};
</script>

<style scoped>
/* ============================================================
   Communications1 — light design system (c1-design.css tokens)
   ============================================================ */
/* Hide sliding panel — replaced by inline top-strip */
.c1-comms-page .c1-panel { display: none !important; }

.cm1-main {
  --c1-bg:      #f4f3f0;
  --c1-surface: #ffffff;
  --c1-surface2:#f4f3f0;
  --c1-border:  #e4e3df;
  --c1-text:    #1a1a1a;
  --c1-muted:   #a09e98;
  --c1-accent:  #7c5cfc;
  --c1-dp:      #2d9d5e;
  --c1-ld:      #d4a017;
  --c1-na:      #e05a3a;
  --c1-sc:      #e8891c;
  --cm1-bg:     var(--c1-bg);
  --cm1-surf:   var(--c1-surface);
  --cm1-surf2:  var(--c1-surface2);
  --cm1-brd:    var(--c1-border);
  --cm1-brd-l:  #eeedea;
  --cm1-t1:     var(--c1-text);
  --cm1-t2:     #6b6963;
  --cm1-t3:     #a09e98;
  --cm1-ac:     var(--c1-accent);
  --cm1-ac-l:   rgba(124,92,252,.1);
  --cm1-green:  #2d9d5e;
  --cm1-red:    #c75450;
  --cm1-amber:  #d4a017;
  --cm1-blue:   #3b82f6;
  --cm1-email:  #7c5cfc;
  --cm1-sms:    #2d9d5e;
  font-family: 'DM Sans', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

/* ── TOP BAR ── */
.cm1-main .c1-tib { background:var(--c1-card, #fff) !important; border-bottom-color:var(--c1-brd, #e4e3df) !important; color:var(--cm1-t2); display:flex; align-items:center; gap:2px; padding:0 8px; height:44px; flex-shrink:0; }
.cm1-main .c1-tib-btn { display:flex; align-items:center; gap:5px; padding:6px 10px; border-radius:7px; cursor:pointer; font-size:11px; font-weight:600; color:var(--cm1-t2); transition:all .12s; position:relative; }
.cm1-main .c1-tib-btn svg { width:14px; height:14px; stroke:currentColor; fill:none; stroke-width:2; }
.cm1-main .c1-tib-btn:hover { background:rgba(0,0,0,.05); color:var(--cm1-t1); }
.cm1-main .c1-tib-btn.on { background:var(--cm1-ac-l); color:var(--cm1-ac); }
.cm1-main .c1-tib-btn.on svg { stroke:var(--cm1-ac); }
.cm1-main .c1-tib-user { width:30px; height:30px; border-radius:50%; background:var(--cm1-ac); color:#fff; font-size:10px; font-weight:700; display:grid; place-items:center; cursor:pointer; position:relative; flex-shrink:0; }
.cm1-main .c1-tib-ini { font-size:10px; font-weight:700; }
.cm1-main .c1-tib-udot { position:absolute; bottom:0; right:0; width:8px; height:8px; border-radius:50%; background:var(--cm1-t3); border:2px solid var(--cm1-surf); }
.cm1-main .c1-tib-udot.online { background:var(--cm1-green); }
.cm1-main .c1-tib-badge { background:var(--cm1-red); color:#fff; border-radius:9px; padding:1px 5px; font-size:9px; font-weight:700; }
.cm1-main .c1-hp { flex:1; }
.cm1-viki-btn { position:relative; }
.cm1-viki-badge { position:absolute; top:2px; right:2px; background:var(--cm1-red); color:#fff; border-radius:9px; padding:0 4px; font-size:8px; font-weight:700; min-width:14px; text-align:center; }

/* .c1-panel-backdrop — defined globally in c1-design.css */

/* ── PANEL (global c1-panel handles fixed sliding drawer) ── */
.cm1-main .c1-panel-hdr-bar { display:flex; align-items:center; gap:8px; padding:10px 14px 8px; border-bottom:1px solid var(--cm1-brd); }
.cm1-main .c1-panel-hdr-bar svg { width:14px; height:14px; stroke:var(--cm1-ac); fill:none; stroke-width:2; flex-shrink:0; }
.cm1-main .c1-panel-hdr-ttl { font-size:12px; font-weight:700; color:var(--cm1-t1); flex:1; }
.cm1-main .c1-panel-hdr-count { font-size:10px; color:var(--cm1-ac); font-weight:600; }
.cm1-main .c1-collapse-btn { width:26px; height:26px; border-radius:6px; border:1px solid var(--cm1-brd); display:grid; place-items:center; cursor:pointer; }
.cm1-main .c1-collapse-btn svg { width:13px; height:13px; stroke:var(--cm1-t2); fill:none; stroke-width:2; }
.cm1-main .c1-collapse-btn:hover { background:var(--cm1-surf2); }
.cm1-main .c1-sl-body { padding:14px 14px 6px; }
.cm1-main .c1-fp-group { margin-bottom:14px; }
.cm1-main .c1-fp-full { width:100%; }
.cm1-main .c1-fp-lbl { font-size:9px; font-weight:700; text-transform:uppercase; letter-spacing:.6px; color:var(--cm1-t3); margin-bottom:7px; display:flex; align-items:center; gap:6px; }
.cm1-main .c1-fp-lbl-badge { background:var(--cm1-ac); color:#fff; border-radius:9px; padding:1px 6px; font-size:9px; }
.cm1-main .c1-fp-opts { display:flex; flex-wrap:wrap; gap:6px; }
.cm1-main .c1-fp-opt { padding:5px 10px; border-radius:20px; border:1px solid var(--cm1-brd); cursor:pointer; font-size:11px; font-weight:500; color:var(--cm1-t2); background:var(--cm1-surf2); transition:all .12s; white-space:nowrap; display:flex; align-items:center; gap:4px; }
.cm1-main .c1-fp-opt svg { stroke:currentColor; fill:none; }
.cm1-main .c1-fp-opt:hover { border-color:var(--cm1-t3); color:var(--cm1-t1); }
.cm1-main .c1-fp-opt.on { background:var(--cm1-ac-l); border-color:var(--cm1-ac); color:var(--cm1-ac); }
.cm1-main .c1-fp-opt.cm1-ch-email.on { border-color:var(--cm1-email); color:var(--cm1-email); background:rgba(99,102,241,.12); }
.cm1-main .c1-fp-opt.cm1-ch-sms.on   { border-color:var(--cm1-sms);   color:var(--cm1-sms);   background:rgba(16,185,129,.12); }
.cm1-main .c1-fp-opt.cm1-st-sent.on      { border-color:var(--cm1-email); color:var(--cm1-email); background:rgba(99,102,241,.1); }
.cm1-main .c1-fp-opt.cm1-st-delivered.on { border-color:var(--cm1-green); color:var(--cm1-green); background:rgba(34,197,94,.1); }
.cm1-main .c1-fp-opt.cm1-st-opened.on    { border-color:var(--cm1-blue);  color:var(--cm1-blue);  background:rgba(59,130,246,.1); }
.cm1-main .c1-fp-opt.cm1-st-pending.on   { border-color:var(--cm1-amber); color:var(--cm1-amber); background:rgba(245,158,11,.1); }
.cm1-main .c1-fp-opt.cm1-st-failed.on    { border-color:var(--cm1-red);   color:var(--cm1-red);   background:rgba(239,68,68,.1); }
.cm1-main .c1-fp-opt.cm1-st-bounced.on   { border-color:#9ca3af; color:var(--cm1-t3); background:rgba(107,114,128,.08); }
.cm1-main .c1-fp-search { position:relative; display:flex; align-items:center; background:var(--cm1-surf2); border:1px solid var(--cm1-brd); border-radius:8px; overflow:hidden; }
.cm1-main .c1-fp-sico { position:absolute; left:10px; width:13px; height:13px; stroke:var(--cm1-t3); fill:none; stroke-width:2; flex-shrink:0; }
.cm1-main .c1-fp-sinput { flex:1; background:none; border:none; outline:none; padding:8px 10px 8px 30px; font-size:12px; color:var(--cm1-t1); font-family:inherit; }
.cm1-main .c1-fp-sinput::placeholder { color:var(--cm1-t3); }
.cm1-main .c1-fp-sclear { padding:0 8px; cursor:pointer; }
.cm1-main .c1-fp-sclear svg { width:13px; height:13px; stroke:var(--cm1-t3); fill:none; stroke-width:2; }

/* Reset bar */
.c1-reset-bar { display:flex; align-items:center; gap:8px; padding:8px 14px; background:rgba(239,68,68,.07); border-bottom:1px solid rgba(239,68,68,.15); cursor:pointer; font-size:11px; font-weight:600; color:var(--cm1-red); }
.c1-reset-bar svg { width:13px; height:13px; stroke:currentColor; fill:none; stroke-width:2; }
.c1-reset-bar-count { margin-left:auto; background:var(--cm1-red); color:#fff; border-radius:9px; padding:1px 7px; font-size:10px; }

/* Agent grid */
.cm1-main .c1-agent-grid { display:flex; flex-wrap:wrap; gap:6px; }
.cm1-main .c1-agent-chip { display:flex; align-items:center; gap:5px; padding:4px 9px 4px 5px; border-radius:20px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); cursor:pointer; transition:all .12s; }
.cm1-main .c1-agent-chip.on { border-color:var(--cm1-ac); background:var(--cm1-ac-l); }
.cm1-main .c1-agent-av { width:20px; height:20px; border-radius:50%; background:var(--cm1-ac); color:#fff; font-size:8px; font-weight:700; display:grid; place-items:center; }
.cm1-main .c1-agent-nm { font-size:11px; color:var(--cm1-t2); }
.cm1-main .c1-agent-chip.on .c1-agent-nm { color:var(--cm1-t1); }

/* Collapse bar */
.cm1-main .c1-collapse-bar { display:flex; align-items:center; justify-content:center; gap:6px; padding:10px; border-top:1px solid var(--cm1-brd); cursor:pointer; font-size:11px; font-weight:600; color:var(--cm1-t3); background:var(--cm1-surf); transition:all .12s; }
.cm1-main .c1-collapse-bar:hover { color:var(--cm1-t1); }
.cm1-main .c1-collapse-bar svg { width:13px; height:13px; stroke:currentColor; fill:none; stroke-width:2.5; }

/* ── CHARTS PANEL ── */
.cm1-main .c1-co-lbl { font-size:9px; font-weight:700; text-transform:uppercase; letter-spacing:.6px; color:var(--cm1-t3); margin-bottom:10px; }
.cm1-main .c1-kpi-row { display:flex; gap:6px; flex-wrap:wrap; }
.cm1-main .c1-kpi { flex:1; min-width:60px; padding:10px 12px; background:var(--cm1-surf2); border:1px solid var(--cm1-brd); border-radius:8px; }
.cm1-main .c1-kpi-lbl { font-size:9px; color:var(--cm1-t3); margin-bottom:4px; }
.cm1-main .c1-kpi-val { font-size:20px; font-weight:700; color:var(--cm1-t1); letter-spacing:-.5px; line-height:1; }

/* Stacked bar chart */
.cm1-stack-chart { display:flex; flex-direction:column; gap:5px; }
.cm1-stack-row { display:flex; align-items:center; gap:8px; }
.cm1-stack-lbl { font-size:10px; color:var(--cm1-t3); width:22px; flex-shrink:0; text-align:right; }
.cm1-stack-track { flex:1; height:10px; border-radius:5px; background:var(--cm1-brd); overflow:hidden; display:flex; }
.cm1-stack-seg { height:100%; transition:width .3s; }
.cm1-seg-email { background:var(--cm1-email); }
.cm1-seg-sms   { background:var(--cm1-sms); }
.cm1-stack-total { font-size:10px; color:var(--cm1-t3); width:22px; }
.cm1-stack-legend { display:flex; gap:12px; margin-top:6px; padding-left:30px; }
.cm1-leg-item { display:flex; align-items:center; gap:5px; font-size:10px; color:var(--cm1-t2); }
.cm1-leg-dot { width:8px; height:8px; border-radius:2px; flex-shrink:0; }

/* Gauges */
.cm1-gauge-wrap { display:flex; gap:8px; justify-content:center; }
.cm1-gauge-svg { width:120px; height:70px; }
.cm1-gauge-num { font-size:16px; font-weight:700; fill:var(--cm1-t1); font-family:'DM Sans',-apple-system,sans-serif; }
.cm1-gauge-sub { font-size:8px; fill:var(--cm1-t3); font-family:'DM Sans',-apple-system,sans-serif; }

/* Donut */
.cm1-donut-wrap { display:flex; align-items:center; gap:16px; padding:4px 0; }
.cm1-donut-svg { width:80px; height:80px; flex-shrink:0; }
.cm1-donut-legend { display:flex; flex-direction:column; gap:8px; }

/* Open rate trend */
.cm1-trend-chart { display:flex; gap:5px; align-items:flex-end; height:60px; }
.cm1-trend-col { flex:1; display:flex; flex-direction:column; align-items:center; gap:4px; height:100%; justify-content:flex-end; }
.cm1-trend-bar { width:100%; background:var(--cm1-ac); border-radius:3px 3px 0 0; min-height:2px; transition:height .3s; opacity:.75; }
.cm1-trend-lbl { font-size:9px; color:var(--cm1-t3); }

/* ── CALENDAR PANEL ── */
.cm1-cal-hdr { display:flex; align-items:center; justify-content:space-between; padding:0 4px 12px; }
.cm1-cal-nav { background:none; border:1px solid var(--cm1-brd); border-radius:6px; width:28px; height:28px; display:grid; place-items:center; cursor:pointer; transition:background .12s; }
.cm1-cal-nav svg { width:13px; height:13px; stroke:var(--cm1-t2); fill:none; stroke-width:2.5; }
.cm1-cal-nav:hover { background:var(--cm1-surf2); }
.cm1-cal-title { font-size:13px; font-weight:600; color:var(--cm1-t1); }
.cm1-cal-dow { display:grid; grid-template-columns:repeat(7,1fr); gap:2px; margin-bottom:4px; }
.cm1-cal-dh { text-align:center; font-size:9px; font-weight:700; color:var(--cm1-t3); padding:3px 0; }
.cm1-cal-week { display:grid; grid-template-columns:repeat(7,1fr); gap:2px; margin-bottom:2px; }
.cm1-cal-day { aspect-ratio:1; display:flex; flex-direction:column; align-items:center; justify-content:center; border-radius:6px; cursor:pointer; font-size:11px; font-weight:500; color:var(--cm1-t2); transition:background .1s,color .1s; position:relative; gap:2px; }
.cm1-cal-day:hover { background:var(--cm1-surf2); color:var(--cm1-t1); }
.cm1-cal-out { opacity:.3; }
.cm1-cal-today { color:var(--cm1-ac); font-weight:700; }
.cm1-cal-sel { background:var(--cm1-ac-l) !important; color:var(--cm1-ac) !important; border:1px solid var(--cm1-ac); }
.cm1-cal-dot { width:4px; height:4px; border-radius:50%; background:var(--cm1-ac); }
.cm1-cal-day-result { margin-top:12px; }
.cm1-cal-row { display:flex; align-items:center; gap:8px; padding:8px 10px; border-radius:8px; background:var(--cm1-surf2); border:1px solid var(--cm1-brd); margin-bottom:6px; cursor:pointer; transition:border-color .12s; }
.cm1-cal-row:hover { border-color:var(--cm1-t3); }
.cm1-cal-row-body { flex:1; min-width:0; }
.cm1-cal-row-client { font-size:12px; font-weight:600; color:var(--cm1-t1); }
.cm1-cal-row-preview { font-size:11px; color:var(--cm1-t3); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.cm1-cal-empty { text-align:center; color:var(--cm1-t3); font-size:11px; padding:16px; }

/* ── VIKI PANEL ── */
.cm1-viki-panel .c1-sl-body { padding:12px 14px 8px; }
.cm1-viki-ok { display:flex; align-items:center; gap:8px; font-size:11px; color:var(--cm1-green); padding:10px 0; }
.cm1-viki-ok svg { width:14px; height:14px; stroke:currentColor; fill:none; stroke-width:2.5; }
.cm1-viki-alert { display:flex; align-items:flex-start; gap:10px; padding:10px 12px; border-radius:8px; border:1px solid; margin-bottom:6px; }
.cm1-viki-bounce { background:rgba(107,114,128,.08); border-color:rgba(107,114,128,.25); }
.cm1-viki-failed { background:rgba(239,68,68,.07); border-color:rgba(239,68,68,.2); }
.cm1-viki-warning { background:rgba(245,158,11,.07); border-color:rgba(245,158,11,.2); }
.cm1-viki-alert-icon svg { width:16px; height:16px; stroke:var(--cm1-amber); fill:none; stroke-width:2; margin-top:1px; flex-shrink:0; }
.cm1-viki-bounce .cm1-viki-alert-icon svg { stroke:var(--cm1-t3); }
.cm1-viki-failed .cm1-viki-alert-icon svg  { stroke:var(--cm1-red); }
.cm1-viki-alert-body { flex:1; min-width:0; }
.cm1-viki-alert-title { font-size:12px; font-weight:600; color:var(--cm1-t1); margin-bottom:3px; }
.cm1-viki-alert-msg { font-size:11px; color:var(--cm1-t2); line-height:1.4; }
.cm1-viki-alert-fix { padding:4px 10px; border-radius:6px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); color:var(--cm1-ac); font-size:10px; font-weight:700; cursor:pointer; flex-shrink:0; }
.cm1-viki-alert-fix:hover { background:var(--cm1-ac-l); }

/* Quota bars */
.cm1-quota-bar-wrap { }
.cm1-quota-labels { display:flex; justify-content:space-between; font-size:10px; color:var(--cm1-t3); margin-bottom:5px; }
.cm1-quota-track { height:8px; border-radius:4px; background:var(--cm1-brd); overflow:hidden; }
.cm1-quota-fill { height:100%; border-radius:4px; transition:width .3s; }
.cm1-quota-email { background:var(--cm1-email); }
.cm1-quota-sms   { background:var(--cm1-sms); }

/* Sequences */
.cm1-seq-row { display:flex; align-items:center; gap:10px; padding:8px 0; border-bottom:1px solid var(--cm1-brd); }
.cm1-seq-av { width:28px; height:28px; border-radius:50%; background:var(--cm1-surf2); border:1px solid var(--cm1-brd); font-size:9px; font-weight:700; color:var(--cm1-t2); display:grid; place-items:center; flex-shrink:0; }
.cm1-seq-body { flex:1; min-width:0; }
.cm1-seq-name { font-size:12px; font-weight:600; color:var(--cm1-t1); }
.cm1-seq-desc { font-size:10px; color:var(--cm1-t3); margin-top:2px; }
.cm1-seq-ch { width:22px; height:22px; border-radius:6px; display:grid; place-items:center; flex-shrink:0; }

/* Bounce list */
.cm1-bounce-row { display:flex; align-items:center; gap:8px; padding:7px 0; border-bottom:1px solid var(--cm1-brd); }
.cm1-bounce-addr { font-family:'JetBrains Mono',monospace; font-size:11px; color:var(--cm1-t1); min-width:0; overflow:hidden; text-overflow:ellipsis; flex:1; }
.cm1-bounce-client { font-size:11px; color:var(--cm1-t2); flex-shrink:0; }
.cm1-bounce-reason { font-size:10px; color:var(--cm1-t3); flex-shrink:0; }

/* ── PROFILE PANEL ── */
.cm1-main .c1-prof-panel { position:fixed; top:44px; right:0; bottom:0; width:min(320px,100vw); background:var(--cm1-bg); border-left:1px solid var(--cm1-brd); z-index:200; display:flex; flex-direction:column; transform:translateX(100%); transition:transform .25s cubic-bezier(.4,0,.2,1), box-shadow .25s; }
.cm1-main .c1-prof-panel.c1-panel--open { transform:translateX(0); box-shadow:-4px 0 24px rgba(0,0,0,.18); }
.cm1-main .c1-prof-head { background:var(--cm1-surf); border-bottom:1px solid var(--cm1-brd); padding:14px; flex-shrink:0; }
.cm1-main .c1-prof-brand-row { display:flex; align-items:center; margin-bottom:12px; }
.cm1-main .c1-prof-brand-name { font-size:14px; font-weight:800; color:var(--cm1-t1); letter-spacing:-.3px; }
.cm1-main .c1-prof-brand-name span { color:var(--cm1-ac); }
.cm1-main .c1-tz-row { display:flex; gap:8px; }
.cm1-main .c1-tz { display:flex; align-items:center; gap:4px; }
.cm1-main .c1-tz-lbl { font-size:9px; color:var(--cm1-t3); font-weight:700; text-transform:uppercase; }
.cm1-main .c1-tz-t { font-size:11px; color:var(--cm1-t1); font-family:'JetBrains Mono',monospace; }
.cm1-main .c1-prof-user-row { display:flex; align-items:center; gap:10px; }
.cm1-main .c1-prof-av { width:36px; height:36px; border-radius:50%; background:var(--cm1-ac); color:#fff; font-size:12px; font-weight:700; display:grid; place-items:center; flex-shrink:0; }
.cm1-main .c1-prof-meta { flex:1; min-width:0; }
.cm1-main .c1-prof-name { font-size:13px; font-weight:600; color:var(--cm1-t1); }
.cm1-main .c1-prof-role { font-size:10px; color:var(--cm1-t3); margin-top:1px; }
.cm1-main .c1-prof-toggle { display:flex; align-items:center; gap:5px; padding:5px 8px; border-radius:8px; border:1px solid var(--cm1-brd); cursor:pointer; font-size:10px; font-weight:600; color:var(--cm1-t3); transition:all .12s; flex-shrink:0; }
.cm1-main .c1-prof-toggle.online { border-color:var(--cm1-green); color:var(--cm1-green); background:rgba(34,197,94,.08); }
.cm1-main .c1-prof-tog-dot { width:7px; height:7px; border-radius:50%; background:var(--cm1-t3); transition:background .12s; }
.cm1-main .c1-prof-toggle.online .c1-prof-tog-dot { background:var(--cm1-green); }
.cm1-main .c1-prof-scroll { flex:1; overflow-y:auto; padding:10px 12px 24px; }
.cm1-main .c1-nc-lbl { font-size:9px; font-weight:700; text-transform:uppercase; letter-spacing:.6px; color:var(--cm1-t3); padding:12px 2px 6px; }
.cm1-main .c1-ng { display:grid; grid-template-columns:1fr 1fr; gap:5px; margin-bottom:6px; }
.cm1-main .c1-nb { display:flex; align-items:center; gap:7px; padding:9px 10px; border-radius:9px; border:1px solid transparent; cursor:pointer; font-size:11px; font-weight:600; text-decoration:none; transition:all .12s; }
.cm1-main .c1-nb svg { width:14px; height:14px; stroke:currentColor; fill:none; stroke-width:2; flex-shrink:0; }
.cm1-main .c1-nb-dp { background:rgba(124,92,252,.08); color:var(--cm1-ac); }
.cm1-main .c1-nb-dp.router-link-exact-active { border-color:var(--cm1-ac); }
.cm1-main .c1-nb-sc { background:rgba(212,160,23,.1); color:var(--cm1-amber); }
.cm1-main .c1-nb-rf { background:rgba(199,84,80,.08); color:var(--cm1-red); }
.cm1-main .c1-nb-na { background:rgba(0,0,0,.04); color:var(--cm1-t2); }
.cm1-main .c1-nb-logout { background:rgba(199,84,80,.08); color:var(--cm1-red); grid-column:1/-1; }
.cm1-main .c1-collapse-bar-lg { margin-top:16px; background:var(--cm1-surf); border-top:1px solid var(--cm1-brd); }

/* ── SUMMARY STRIP ── */
.cm1-summary { display:flex; align-items:center; padding:10px 14px; background:var(--cm1-surf); border-bottom:1px solid var(--cm1-brd); flex-shrink:0; flex-wrap:wrap; gap:4px; }
.cm1-sum-item { display:flex; flex-direction:column; align-items:center; min-width:48px; }
.cm1-sum-val { font-size:18px; font-weight:700; color:var(--cm1-t1); line-height:1; letter-spacing:-.5px; }
.cm1-sum-lbl { font-size:9px; font-weight:600; text-transform:uppercase; letter-spacing:.4px; color:var(--cm1-t3); margin-top:3px; white-space:nowrap; }
.cm1-sum-sep { width:1px; height:30px; background:var(--cm1-brd); margin:0 8px; flex-shrink:0; }
.cm1-green  { color:var(--cm1-green) !important; }
.cm1-red    { color:var(--cm1-red)   !important; }
.cm1-purple { color:var(--cm1-ac)    !important; }
.cm1-amber  { color:var(--cm1-amber) !important; }
.cm1-blue   { color:var(--cm1-blue)  !important; }

.cm1-compose-btn { display:flex; align-items:center; gap:5px; padding:7px 14px; border-radius:8px; border:none; background:var(--cm1-ac); color:#fff; font-size:12px; font-weight:600; cursor:pointer; transition:opacity .12s; }
.cm1-compose-btn:hover { opacity:.88; }
.cm1-compose-btn svg { width:13px; height:13px; stroke:currentColor; fill:none; stroke-width:2.5; }

/* ── STATUS CHIPS ── */
.cm1-st-chip { display:inline-flex; align-items:center; padding:2px 8px; border-radius:20px; font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.3px; white-space:nowrap; flex-shrink:0; }
.cm1-st-sent      { background:rgba(99,102,241,.15); color:var(--cm1-email); }
.cm1-st-delivered { background:rgba(34,197,94,.12);  color:var(--cm1-green); }
.cm1-st-opened    { background:rgba(59,130,246,.12);  color:var(--cm1-blue); }
.cm1-st-pending   { background:rgba(245,158,11,.12);  color:var(--cm1-amber); }
.cm1-st-failed    { background:rgba(239,68,68,.12);   color:var(--cm1-red); }
.cm1-st-bounced   { background:rgba(107,114,128,.1); color:var(--cm1-t3); }

/* ── LOADING / EMPTY ── */
.c1-loading { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:60px 20px; }
.c1-spinner { width:22px; height:22px; border:2px solid var(--cm1-brd); border-top-color:var(--cm1-ac); border-radius:50%; animation:cm1spin .7s linear infinite; }
@keyframes cm1spin { to { transform:rotate(360deg); } }
.c1-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:60px 20px; gap:12px; }
.c1-empty-icon svg { width:40px; height:40px; stroke:var(--cm1-t3); fill:none; stroke-width:1.5; }
.c1-empty-msg { font-size:13px; color:var(--cm1-t3); }

/* ── COMM LIST ── */
.cm1-list { flex:1; display:flex; flex-direction:column; }
.cm1-row { border-bottom:1px solid var(--cm1-brd); transition:background .1s; }
.cm1-row-bounced { opacity:.85; }
.cm1-row:last-child { border-bottom:none; }
.cm1-row-head { display:flex; align-items:center; gap:8px; padding:10px 12px 10px 10px; cursor:pointer; transition:background .1s; position:relative; min-height:48px; }
.cm1-row-head:hover { background:var(--cm1-surf); }
.cm1-row-head.cm1-row-expanded { background:var(--cm1-surf); }
.cm1-row-acc { width:3px; height:32px; border-radius:3px; flex-shrink:0; }
.cm1-acc-email { background:var(--cm1-email); }
.cm1-acc-sms   { background:var(--cm1-sms); }
.cm1-row-ts { font-size:10px; color:var(--cm1-t3); width:68px; flex-shrink:0; font-family:'JetBrains Mono',monospace; }
.cm1-row-ch { width:26px; height:26px; border-radius:8px; display:grid; place-items:center; flex-shrink:0; }
.cm1-ch-bg-email { background:rgba(99,102,241,.15); color:var(--cm1-email); }
.cm1-ch-bg-sms   { background:rgba(16,185,129,.15);  color:var(--cm1-sms); }
.cm1-row-ch svg { stroke:currentColor; fill:none; }
.cm1-row-client { font-size:12px; font-weight:600; color:var(--cm1-t1); min-width:90px; max-width:110px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; flex-shrink:0; }
.cm1-bounced-name { color:var(--cm1-t3); text-decoration:line-through; }
.cm1-row-subject { flex:1; display:flex; min-width:0; overflow:hidden; }
.cm1-row-subj-text { font-size:11px; font-weight:600; color:var(--cm1-t2); flex-shrink:0; }
.cm1-row-preview { font-size:11px; color:var(--cm1-t3); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; min-width:0; }
.cm1-row-agent { width:22px; height:22px; border-radius:50%; background:var(--cm1-surf2); border:1px solid var(--cm1-brd); font-size:8px; font-weight:700; color:var(--cm1-t2); display:grid; place-items:center; flex-shrink:0; }
.cm1-row-chv { width:14px; height:14px; flex-shrink:0; transition:transform .15s; }
.cm1-row-chv.open { transform:rotate(180deg); }

/* ── EXPANDED ROW BODY ── */
.cm1-row-body { padding:12px 16px 14px; border-top:1px solid var(--cm1-brd); background:var(--cm1-surf); }
.cm1-exp-sec { margin-bottom:14px; }
.cm1-exp-lbl { font-size:9px; font-weight:700; text-transform:uppercase; letter-spacing:.6px; color:var(--cm1-t3); margin-bottom:8px; display:flex; align-items:center; gap:6px; }
.cm1-exp-msg { font-size:12px; color:var(--cm1-t1); line-height:1.6; background:var(--cm1-surf2); border:1px solid var(--cm1-brd); border-radius:8px; padding:10px 12px; white-space:pre-wrap; word-break:break-word; }
.cm1-exp-msg-lg { font-size:13px; }
.cm1-exp-grid { display:grid; grid-template-columns:1fr 1fr; gap:6px; }
.cm1-exp-full { grid-column:1/-1; }
.cm1-exp-field { background:var(--cm1-surf2); border:1px solid var(--cm1-brd); border-radius:8px; padding:7px 10px; }
.cm1-exp-fl { font-size:9px; color:var(--cm1-t3); margin-bottom:3px; text-transform:uppercase; letter-spacing:.4px; }
.cm1-exp-fv { font-size:12px; color:var(--cm1-t1); font-weight:500; }
.cm1-mono { font-family:'JetBrains Mono',monospace; }

/* Banners */
.cm1-bounce-banner { display:flex; align-items:flex-start; gap:8px; padding:10px 12px; background:rgba(107,114,128,.08); border:1px solid rgba(107,114,128,.2); border-radius:8px; margin-bottom:12px; font-size:12px; color:var(--cm1-t2); line-height:1.5; }
.cm1-bounce-banner svg { width:14px; height:14px; stroke:var(--cm1-t3); fill:none; stroke-width:2; flex-shrink:0; margin-top:1px; }
.cm1-bounce-banner strong { color:var(--cm1-t1); }
.cm1-spam-banner { display:flex; align-items:flex-start; gap:8px; padding:10px 12px; background:rgba(245,158,11,.08); border:1px solid rgba(245,158,11,.2); border-radius:8px; margin-bottom:12px; font-size:12px; color:var(--cm1-amber); line-height:1.5; }
.cm1-spam-banner svg { width:14px; height:14px; stroke:var(--cm1-amber); fill:none; stroke-width:2; flex-shrink:0; margin-top:1px; }
.cm1-unsub-banner { display:flex; align-items:center; gap:8px; padding:9px 12px; background:rgba(239,68,68,.07); border:1px solid rgba(239,68,68,.15); border-radius:8px; margin-bottom:12px; font-size:12px; color:var(--cm1-red); }
.cm1-unsub-banner svg { width:14px; height:14px; stroke:currentColor; fill:none; stroke-width:2; flex-shrink:0; }
.cm1-act-unsub-badge { padding:4px 10px; border-radius:20px; background:rgba(239,68,68,.12); color:var(--cm1-red); font-size:10px; font-weight:700; }

/* Thread */
.cm1-thread { display:flex; flex-direction:column; gap:8px; max-height:300px; }
.cm1-thread-scroll { overflow-y:auto; padding-right:4px; }
.cm1-thread-msg { padding:8px 10px; border-radius:8px; }
.cm1-thread-inbound  { background:var(--cm1-surf2); border:1px solid var(--cm1-brd); align-self:flex-start; max-width:90%; }
.cm1-thread-outbound { background:var(--cm1-ac-l); border:1px solid rgba(99,102,241,.2); align-self:flex-end; max-width:90%; }
.cm1-thread-meta { display:flex; align-items:center; justify-content:space-between; gap:8px; margin-bottom:4px; }
.cm1-thread-who { font-size:10px; font-weight:700; color:var(--cm1-t2); }
.cm1-thread-ts { font-size:9px; color:var(--cm1-t3); }
.cm1-thread-body { font-size:12px; color:var(--cm1-t1); line-height:1.5; white-space:pre-wrap; word-break:break-word; }
.cm1-thread-more { text-align:center; padding:8px; font-size:11px; color:var(--cm1-ac); cursor:pointer; }
.cm1-thread-more:hover { text-decoration:underline; }
.cm1-thread-hist-btn { text-align:center; padding:8px; font-size:11px; color:var(--cm1-ac); cursor:pointer; border-top:1px solid var(--cm1-brd); margin-top:4px; }
.cm1-thread-tab-hint { color:var(--cm1-t3); font-weight:400; text-transform:none; letter-spacing:0; font-size:9px; }

/* Action buttons */
.cm1-exp-actions { display:flex; flex-wrap:wrap; gap:6px; }
.cm1-act-btn { display:flex; align-items:center; gap:5px; padding:6px 12px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); cursor:pointer; font-size:11px; font-weight:600; color:var(--cm1-t2); text-decoration:none; transition:all .12s; }
.cm1-act-btn svg { width:12px; height:12px; stroke:currentColor; fill:none; stroke-width:2; }
.cm1-act-btn:hover { border-color:var(--cm1-t3); color:var(--cm1-t1); }
.cm1-act-detail:hover  { border-color:var(--cm1-blue);  color:var(--cm1-blue); }
.cm1-act-retry:hover   { border-color:var(--cm1-amber); color:var(--cm1-amber); }
.cm1-act-compose:hover { border-color:var(--cm1-ac);    color:var(--cm1-ac); }
.cm1-act-client:hover  { border-color:var(--cm1-green); color:var(--cm1-green); }
/* UNSUBSCRIBE — most prominent */
.cm1-act-unsub { border-color:rgba(239,68,68,.3); color:var(--cm1-red); font-size:12px; font-weight:700; background:rgba(239,68,68,.07); }
.cm1-act-unsub:hover { background:rgba(239,68,68,.12); border-color:var(--cm1-red); }

/* SMS deposit management reply buttons */
.cm1-mgmt-btns { display:flex; flex-wrap:wrap; gap:6px; }
.cm1-mgmt-btn { padding:6px 12px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); font-size:11px; font-weight:600; cursor:pointer; transition:all .12s; }
.cm1-mgmt-congrats { color:var(--cm1-amber); border-color:rgba(212,160,23,.25); }
.cm1-mgmt-great    { color:var(--cm1-green); border-color:rgba(34,197,94,.2); }
.cm1-mgmt-more     { color:var(--cm1-blue); border-color:rgba(59,130,246,.2); }
.cm1-mgmt-close    { color:var(--cm1-ac); border-color:var(--cm1-ac-l); }
.cm1-mgmt-free { display:flex; align-items:center; gap:6px; flex:1; min-width:200px; }
.cm1-mgmt-input { flex:1; background:var(--cm1-surf2); border:1px solid var(--cm1-brd); border-radius:7px; padding:6px 9px; font-size:11px; color:var(--cm1-t1); outline:none; font-family:inherit; }
.cm1-mgmt-input:focus { border-color:var(--cm1-ac); }
.cm1-mgmt-send { padding:6px 12px; border-radius:7px; border:none; background:var(--cm1-ac); color:#fff; font-size:11px; font-weight:700; cursor:pointer; flex-shrink:0; }

/* ── PAGINATION ── */
.c1-pg-bar { display:flex; align-items:center; gap:4px; padding:8px 12px; border-bottom:1px solid var(--cm1-brd); background:var(--cm1-surf); flex-shrink:0; }
.c1-pg-btn { width:28px; height:28px; border-radius:6px; display:grid; place-items:center; cursor:pointer; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); transition:all .12s; }
.c1-pg-btn svg { width:13px; height:13px; stroke:var(--cm1-t2); fill:none; stroke-width:2.5; }
.c1-pg-btn:hover { border-color:var(--cm1-t3); }
.c1-pg-btn.disabled { opacity:.3; pointer-events:none; }
.c1-pg-info { font-size:11px; color:var(--cm1-t3); padding:0 6px; }

/* ── RIGHT DRAWER — detail ── */
.cm1-drawer-wrap { position:fixed; inset:0; z-index:500; background:rgba(0,0,0,.55); display:flex; justify-content:flex-end; }
.cm1-drawer { width:min(440px,100vw); background:var(--cm1-surf); border-left:1px solid var(--cm1-brd); display:flex; flex-direction:column; overflow:hidden; height:100%; }
.cm1-drawer-head { display:flex; align-items:center; gap:10px; padding:14px 16px; border-bottom:1px solid var(--cm1-brd); flex-shrink:0; background:var(--cm1-surf2); }
.cm1-drawer-ch { width:32px; height:32px; border-radius:10px; display:grid; place-items:center; flex-shrink:0; }
.cm1-drawer-title { flex:1; min-width:0; }
.cm1-drawer-name { font-size:13px; font-weight:600; color:var(--cm1-t1); }
.cm1-drawer-sub { font-size:11px; color:var(--cm1-t3); margin-top:2px; }
.cm1-drawer-close { width:28px; height:28px; border-radius:6px; border:none; background:var(--cm1-surf); cursor:pointer; display:grid; place-items:center; transition:background .12s; flex-shrink:0; }
.cm1-drawer-close:hover { background:var(--cm1-brd); }
.cm1-drawer-close svg { width:14px; height:14px; }
.cm1-drawer-body { flex:1; overflow-y:auto; padding:16px; -webkit-overflow-scrolling:touch; }

/* Unsubscribe main button in drawer */
.cm1-unsub-main-btn { width:100%; padding:11px 14px; border-radius:10px; border:2px solid var(--cm1-red); background:rgba(239,68,68,.08); color:var(--cm1-red); font-size:13px; font-weight:700; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:7px; transition:all .15s; margin-bottom:14px; }
.cm1-unsub-main-btn:hover { background:rgba(239,68,68,.15); }
.cm1-unsub-main-btn svg { width:16px; height:16px; stroke:currentColor; fill:none; stroke-width:2.5; }

/* Timeline */
.cm1-timeline { display:flex; flex-direction:column; gap:0; }
.cm1-tl-item { display:flex; align-items:center; gap:10px; padding:8px 0; position:relative; }
.cm1-tl-item:not(:last-child)::after { content:''; position:absolute; left:6px; top:calc(50% + 10px); width:1px; height:calc(100% - 4px); background:var(--cm1-brd); }
.cm1-tl-dot { width:13px; height:13px; border-radius:50%; flex-shrink:0; border:2px solid var(--cm1-brd); background:var(--cm1-surf2); }
.cm1-tl-sent .cm1-tl-dot      { background:var(--cm1-ac);    border-color:var(--cm1-ac); }
.cm1-tl-delivered .cm1-tl-dot { background:var(--cm1-green); border-color:var(--cm1-green); }
.cm1-tl-opened .cm1-tl-dot    { background:var(--cm1-blue);  border-color:var(--cm1-blue); }
.cm1-tl-pending .cm1-tl-dot   { opacity:.4; }
.cm1-tl-bounced .cm1-tl-dot   { background:var(--cm1-t3); border-color:var(--cm1-t3); }
.cm1-tl-label { font-size:11px; font-weight:600; color:var(--cm1-t2); flex:1; }
.cm1-tl-time { font-size:10px; color:var(--cm1-t3); font-family:'JetBrains Mono',monospace; }

/* Reply input in drawer */
.cm1-reply-wrap { display:flex; flex-direction:column; gap:6px; }
.cm1-reply-input { width:100%; padding:10px 12px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); color:var(--cm1-t1); font-size:12px; font-family:inherit; resize:vertical; outline:none; transition:border-color .12s; line-height:1.5; box-sizing:border-box; }
.cm1-reply-input:focus { border-color:var(--cm1-ac); }
.cm1-reply-footer { display:flex; align-items:center; justify-content:space-between; }
.cm1-reply-send-btn { display:flex; align-items:center; gap:6px; padding:7px 14px; border-radius:8px; border:none; background:var(--cm1-ac); color:#fff; font-size:12px; font-weight:700; cursor:pointer; transition:opacity .12s; }
.cm1-reply-send-btn:disabled { opacity:.35; pointer-events:none; }
.cm1-reply-send-btn svg { width:13px; height:13px; stroke:currentColor; fill:none; stroke-width:2; }

/* Drawer action buttons */
.cm1-drawer-actions { display:flex; flex-wrap:wrap; gap:8px; }
.cm1-dact-btn { display:flex; align-items:center; gap:6px; padding:8px 14px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); cursor:pointer; font-size:12px; font-weight:600; color:var(--cm1-t2); text-decoration:none; transition:all .12s; }
.cm1-dact-btn svg { width:13px; height:13px; stroke:currentColor; fill:none; stroke-width:2; }
.cm1-dact-btn:hover { border-color:var(--cm1-t3); color:var(--cm1-t1); }
.cm1-dact-reply:hover     { border-color:var(--cm1-ac);    color:var(--cm1-ac);    background:var(--cm1-ac-l); }
.cm1-dact-forward:hover   { border-color:var(--cm1-blue);  color:var(--cm1-blue); }
.cm1-dact-important:hover, .cm1-dact-important.on { border-color:var(--cm1-amber); color:var(--cm1-amber); background:rgba(245,158,11,.08); }
.cm1-dact-client:hover    { border-color:var(--cm1-green); color:var(--cm1-green); }

/* Drawer transition */
.cm1-drawer-enter-active, .cm1-drawer-leave-active { transition:transform .25s cubic-bezier(.4,0,.2,1); }
.cm1-drawer-enter, .cm1-drawer-leave-to { transform:translateX(100%); }

/* ── LEFT DRAWER — compose ── */
.cm1-compose-wrap { position:fixed; inset:0; z-index:500; background:rgba(0,0,0,.55); display:flex; justify-content:flex-start; }
.cm1-compose-panel { width:min(420px,100vw); background:var(--cm1-surf); border-right:1px solid var(--cm1-brd); display:flex; flex-direction:column; height:100%; }
.cm1-compose-head { display:flex; align-items:center; gap:8px; padding:14px 16px; border-bottom:1px solid var(--cm1-brd); flex-shrink:0; background:var(--cm1-surf2); font-size:13px; font-weight:600; color:var(--cm1-t1); }
.cm1-compose-head svg { width:15px; height:15px; stroke:var(--cm1-ac); fill:none; stroke-width:2; flex-shrink:0; }
.cm1-compose-body { flex:1; overflow-y:auto; padding:16px; display:flex; flex-direction:column; gap:14px; }
.cm1-compose-group { display:flex; flex-direction:column; }
.cm1-compose-lbl { font-size:9px; font-weight:700; text-transform:uppercase; letter-spacing:.6px; color:var(--cm1-t3); margin-bottom:7px; }
.cm1-compose-rule-note { color:var(--cm1-red); font-size:9px; text-transform:none; letter-spacing:0; font-weight:600; display:block; margin-top:2px; }

/* Client dropdown */
.cm1-client-dropdown { position:absolute; top:100%; left:0; right:0; background:var(--cm1-surf); border:1px solid var(--cm1-brd); border-radius:8px; z-index:50; overflow:hidden; margin-top:2px; box-shadow:0 8px 24px rgba(0,0,0,.4); }
.cm1-client-opt { display:flex; align-items:center; gap:10px; padding:9px 12px; cursor:pointer; transition:background .1s; }
.cm1-client-opt:hover { background:var(--cm1-surf2); }
.cm1-client-opt-name { font-size:12px; font-weight:600; color:var(--cm1-t1); flex:1; }
.cm1-client-opt-contact { font-size:10px; color:var(--cm1-t3); }
.cm1-client-selected { display:flex; align-items:center; gap:6px; font-size:11px; font-weight:600; color:var(--cm1-green); margin-top:6px; }
.cm1-client-selected svg { width:12px; height:12px; stroke:currentColor; fill:none; stroke-width:2.5; }

/* Email presets */
.cm1-preset-grid { display:flex; flex-direction:column; gap:6px; }
.cm1-preset-card { padding:10px 12px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); cursor:pointer; transition:all .12s; }
.cm1-preset-card:hover { border-color:var(--cm1-t3); }
.cm1-preset-card.on { border-color:var(--cm1-ac); background:var(--cm1-ac-l); }
.cm1-preset-name { font-size:12px; font-weight:600; color:var(--cm1-t1); margin-bottom:3px; }
.cm1-preset-preview { font-size:10px; color:var(--cm1-t3); line-height:1.4; }
.cm1-preset-card.on .cm1-preset-preview { color:var(--cm1-t2); }

/* Compose textarea / input */
.cm1-compose-select { width:100%; padding:8px 10px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); color:var(--cm1-t1); font-size:12px; font-family:inherit; outline:none; cursor:pointer; }
.cm1-compose-select:focus { border-color:var(--cm1-ac); }
.cm1-compose-textarea { width:100%; padding:10px 12px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); color:var(--cm1-t1); font-size:12px; font-family:inherit; resize:vertical; outline:none; transition:border-color .12s; line-height:1.6; box-sizing:border-box; }
.cm1-compose-textarea:focus { border-color:var(--cm1-ac); }
.cm1-compose-input { width:100%; padding:8px 10px; border-radius:8px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); color:var(--cm1-t1); font-size:12px; font-family:inherit; outline:none; box-sizing:border-box; }
.cm1-compose-input:focus { border-color:var(--cm1-ac); }
.cm1-compose-count { font-size:9px; color:var(--cm1-t3); text-align:right; margin-top:4px; }
.cm1-count-warn { color:var(--cm1-red) !important; font-weight:700; }

/* Compose warning */
.cm1-compose-warning { display:flex; align-items:flex-start; gap:8px; padding:10px 12px; background:rgba(245,158,11,.08); border:1px solid rgba(245,158,11,.2); border-radius:8px; font-size:11px; color:var(--cm1-amber); line-height:1.5; }
.cm1-compose-warning svg { width:14px; height:14px; stroke:currentColor; fill:none; stroke-width:2; flex-shrink:0; margin-top:1px; }

/* Schedule toggle */
.cm1-schedule-row { display:flex; align-items:center; cursor:pointer; }
.cm1-schedule-toggle { width:34px; height:18px; border-radius:9px; border:1px solid var(--cm1-brd); background:var(--cm1-surf2); position:relative; transition:background .15s,border-color .15s; flex-shrink:0; }
.cm1-schedule-toggle.on { background:var(--cm1-ac); border-color:var(--cm1-ac); }
.cm1-schedule-dot { width:12px; height:12px; border-radius:50%; background:var(--cm1-t3); position:absolute; top:2px; left:2px; transition:transform .15s,background .15s; }
.cm1-schedule-toggle.on .cm1-schedule-dot { background:#fff; transform:translateX(16px); }

/* Send button */
.cm1-compose-send { width:100%; padding:11px; border-radius:10px; border:none; background:var(--cm1-ac); color:#fff; font-size:13px; font-weight:700; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:7px; transition:opacity .12s; margin-top:auto; }
.cm1-compose-send:hover { opacity:.88; }
.cm1-compose-send:disabled { opacity:.35; pointer-events:none; }
.cm1-compose-send svg { width:14px; height:14px; stroke:currentColor; fill:none; stroke-width:2; }

/* Compose transition */
.cm1-compose-enter-active, .cm1-compose-leave-active { transition:transform .25s cubic-bezier(.4,0,.2,1); }
.cm1-compose-enter, .cm1-compose-leave-to { transform:translateX(-100%); }

/* Toast */
.cm1-toast { position:fixed; bottom:28px; left:50%; transform:translateX(-50%); z-index:99999; padding:10px 22px; border-radius:24px; color:#fff; font-size:.85rem; font-weight:600; box-shadow:0 4px 20px rgba(0,0,0,.25); pointer-events:none; white-space:nowrap; height:auto; display:inline-flex; align-items:center; }
.cm1-toast-fade-enter-active, .cm1-toast-fade-leave-active { transition:opacity .25s,transform .25s; }
.cm1-toast-fade-enter, .cm1-toast-fade-leave-to { opacity:0; transform:translateX(-50%) translateY(10px); }

/* ── TAB BAR ── */
.cm1-tab-bar {
  display: flex;
  background: var(--cm1-surf);
  border-bottom: 1px solid var(--cm1-brd);
  flex-shrink: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.cm1-tab {
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--cm1-t3);
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition: color 0.15s, border-color 0.15s;
  flex-shrink: 0;
}
.cm1-tab:hover {
  color: var(--cm1-t1);
}
.cm1-tab--active {
  color: var(--cm1-ac);
  border-bottom-color: var(--cm1-ac);
}

/* ── TAB CONTENT ── */
.cm1-tab-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
}
.cm1-tab-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--cm1-t1);
  margin-bottom: 14px;
}
.cm1-tab-section-title svg {
  stroke: var(--cm1-ac);
  fill: none;
  flex-shrink: 0;
}
.cm1-tab-loading {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.cm1-tab-empty {
  text-align: center;
  color: var(--cm1-t3);
  font-size: 12px;
  padding: 24px 0;
}

/* ── STATS TABLE ── */
.cm1-stats-table {
  border: 1px solid var(--cm1-brd);
  border-radius: 10px;
  overflow: hidden;
  background: var(--cm1-surf);
}
.cm1-stats-thead {
  display: flex;
  background: var(--cm1-surf2);
  border-bottom: 1px solid var(--cm1-brd);
}
.cm1-stats-th {
  flex: 1;
  padding: 9px 12px;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cm1-t3);
}
.cm1-stats-row {
  display: flex;
  border-bottom: 1px solid var(--cm1-brd-l);
  transition: background 0.1s;
}
.cm1-stats-row:last-child {
  border-bottom: none;
}
.cm1-stats-row:hover {
  background: rgba(124,92,252,0.03);
}
.cm1-stats-td {
  flex: 1;
  padding: 10px 12px;
  font-size: 12px;
  color: var(--cm1-t1);
  display: flex;
  align-items: center;
  gap: 8px;
}
.cm1-stats-av {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--cm1-ac);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cm1-purple { color: #7c5cfc; }

/* ── RESPONSIVE ── */
@media (max-width: 480px) {
  .cm1-row-ts    { display:none; }
  .cm1-row-agent { display:none; }
  .cm1-sum-sep   { display:none; }
  .cm1-summary   { gap:8px; justify-content:space-between; }
  .cm1-sum-item  { min-width:40px; }
  .cm1-exp-grid  { grid-template-columns:1fr; }
  .cm1-drawer, .cm1-compose-panel { width:100vw; }
  .cm1-gauge-wrap { flex-direction:column; align-items:center; }
  .cm1-tab { padding: 8px 10px; font-size: 10px; }
  .cm1-stats-th, .cm1-stats-td { padding: 8px 6px; font-size: 10px; }
}
</style>
